<template>
    <div>
        <div id="title">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h3 v-bind:class="{'border-bottom': empty}">
                            Корзина<span v-if="sets.lenght > 0"> - Ваш заказ</span>
                            <!--<a href="/configurator" class="btn btn-outline-primary"><i class="las la-angle-left"></i> Вернуться в конфигуратор</a>-->
                        </h3>
                    </div>

<!--                    <div class="col-md-12 tabs">-->
<!--                        <div class="row">-->
<!--                            <a class="col-4 tab" v-bind:class="{ active: mode == 1 }" @click="setMode(1)">-->
<!--                                <span>Заказ комплектующих</span>-->
<!--                            </a>-->
<!--                            <a class="col-4 tab" v-bind:class="{ active: mode == 2 }" @click="setMode(2)">-->
<!--                                <span>Готовые изделия со склада</span>-->
<!--                            </a>-->
<!--                            <a class="col-4 tab" v-bind:class="{ active: mode == 3 }" @click="setMode(3)">-->
<!--                                <span>Готовые изделия под заказ</span>-->
<!--                            </a>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>
            </div>
        </div>
        <main role="main" class="container" style="margin-top: -7px !important;">
            <div class="row">
                <div class="col-md-12 preview" v-if="mode == 1">
                    <div v-if="sets.length > 0 && !empty">
                        <table class="table" v-for="set in sets" v-bind:key="set.id">
                            <tbody>
                            <tr v-if="set.inBusket && !(set.id == 0 && handEmpty)" class="setHead">
                                <td v-if="set.id != 0" colspan="6" class="text-center">
                                    <span style="padding: 7px 0; display: inline-block;">Комплект "{{set.hh}} {{set.hh_add}}"</span>
                                    <span v-if="set.full"><br/>Комплексный заказ</span>
                                    <span v-else class="red"><br/>Не комплексный заказ</span>
                                    <button class="btn btn-primary ml-2 removeSet" @click="remove(set.id)"><i class="las la-trash"></i> Комплект</button>
                                </td>
                                <td v-if="set.id == 0" colspan="6" class="text-center">Добавлено ручным способом</td>
                            </tr>
                            </tbody>
                            <tbody>
                                <tr class="tableHeader">
                                    <td style="border-top: none;">Фото <br><i class="las la-angle-down"></i></td>
                                    <td style="border-top: none;">Наименование <br><i class="las la-angle-down"></i></td>
                                    <td style="border-top: none;">Кол-во <br><i class="las la-angle-down"></i></td>
                                    <td style="border-top: none;">Цена по Прайсу <br><i class="las la-angle-down"></i></td>
                                    <td style="border-top: none;">Цена со Скидкой <br><i class="las la-angle-down"></i></td>
                                    <td style="border-top: none;" v-if="!set.full" class="aiField">При интеллектуальном заказе (комплексном) <br> цена составит <br><i class="las la-angle-down"></i></td>
                                </tr>
                            </tbody>
                            <tbody>
                                <!--<tr v-if="set.inBusket && !(set.id == 0 && handEmpty)">-->
                                    <!--<td v-if="set.id != 0" colspan="6" class="text-center">-->
                                        <!--<span style="padding: 7px; display: inline-block;">Комплект "{{set.hh}} {{set.hh_add}}"</span>-->
                                        <!--<button class="btn btn-primary ml-2 removeSet" @click="remove(set.id)"><i class="las la-trash"></i> Комплект</button>-->
                                    <!--</td>-->
                                    <!--<td v-if="set.id == 0" colspan="6" class="text-center">Добавлено ручным способом</td>-->
                                <!--</tr>-->
                                <tr class="item" v-for="item in set.items" v-bind:key="item.id">
                                    <td data-label="Фото" v-if="set.inBusket" class="noAfter">
                                        <silentbox-single :src="'https://sale.katris.ru/uploads/images/saleKatrisCatalog/' + item.img + '.png'" :autoplay="true" :description="item.name">
                                            <img :src="'https://sale.katris.ru/uploads/___res_w80_q60/images/saleKatrisCatalog/' + item.img + '.png'"
                                                 :alt="item.name" width="60px"
                                                 height="45px">
                                        </silentbox-single>
                                    </td>
                                    <td data-label="Наименование" v-if="set.inBusket"><span v-html="item.name"></span></td>
                                    <td data-label="Кол-во" v-if="set.inBusket">{{item.count}} {{item.measure}}</td>
                                    <td data-label="Цена по Прайсу" v-if="set.inBusket" class="sum">
                                        <div>
                                            <span class="allSum">{{item.sum}} руб.</span>
                                            <span class="pricePerOne">{{item.priceRub | fixed}} руб./{{item.measure}}</span>
                                        </div>
                                    </td>
                                    <td data-label="Цена со Скидкой" v-if="set.inBusket" class="saleSum" v-bind:class="{'noAfter': set.full}">
                                        <div class="totalSale" v-if="action4.indexOf(item.id) == -1">
                                            -<span v-if="item.boxAction">{{item.real_sale + 3}}</span><span v-else>{{item.real_sale}}</span>% <span v-if="item.boxAction" style="color: grey">({{item.real_sale}}+3)</span>
                                        </div>
                                        <div v-else class="totalSale"><br/></div>
                                        <div>
                                            <span class="allSaleSum">{{item.sale_sum | fixed}} руб.</span>
                                            <span class="pricePerOne">{{item.priceRubSale | fixed}} руб./{{item.measure}}</span>
                                        </div>
                                    </td>
                                    <td data-label="При интеллектуальном заказе (комплексном) цена составит" v-if="!set.full" class="saleSum noAfter aiField">
                                        <div v-if="item.aiCalculatedPrice != 0 && action4.indexOf(item.id) == -1" class="totalSale">
                                            -<span v-if="!item.boxAction">{{item.aiCalculatedSale}}</span><span v-else>{{item.aiCalculatedSale + 3}}</span>% <span v-if="item.boxAction" style="color: grey">({{item.aiCalculatedSale}}+3)</span>
                                        </div>
                                        <div v-else class="totalSale"><br/></div>
                                        <div v-if="item.aiCalculatedPrice != 0">
                                            <span class="allSaleSum">{{item.aiCalculatedSum | fixed}} руб.</span>
                                            <span class="pricePerOne">{{item.aiCalculatedPrice | fixed}} руб./{{item.measure}}</span>
                                        </div>
                                        <div v-else></div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <table v-if="!empty && manualFlag" class="table">
                        <tbody>
                        <tr>
                            <td v-if="!manualAICalculated" colspan="6" class="text-center">Добавлено ручным способом</td>
                            <td v-else colspan="7" class="text-center">Добавлено ручным способом</td>
                        </tr>
                        </tbody>
                        <tbody>
                        <tr class="tableHeader">
                            <td style="border-top: none;">Фото <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Наименование <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Кол-во <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Цена по Прайсу <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Цена со Скидкой <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;" v-if="manualAICalculated" class="aiField">При интеллектуальном заказе (комплексном) <br> цена составит <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Удалить <br><i class="las la-angle-down"></i></td>
                        </tr>
                        </tbody>
                        <tbody>
                            <tr class="item" v-for="item in manualSet.items" v-bind:key="item.id">
                                <td data-label="Фото" class="noAfter">
                                    <silentbox-single :src="'https://sale.katris.ru/uploads/images/saleKatrisCatalog/' + item.img + '.png'" :autoplay="true" :description="item.name">
                                        <img :src="'https://sale.katris.ru/uploads/___res_w80_q60/images/saleKatrisCatalog/' + item.img + '.png'"
                                             :alt="item.name" width="60px"
                                             height="45px">
                                    </silentbox-single>
                                </td>
                                <td data-label="Наименование">{{item.name}}</td>
                                <td data-label="Кол-во">{{item.count}} {{item.measure}}</td>
                                <td data-label="Цена по Прайсу" class="sum">
                                    <div>
                                        <span class="allSum">{{item.sum}} руб.</span>
                                        <span class="pricePerOne">{{item.priceRub | fixed}} руб./{{item.measure}}</span>
                                    </div>
                                </td>
                                <td data-label="Цена со Скидкой" class="saleSum">
                                    <div class="totalSale" v-if="action4.indexOf(item.id) == -1">
                                        -<span v-if="item.boxAction">{{item.real_sale + 3}}</span><span v-else>{{item.real_sale}}</span>% <span v-if="item.boxAction" style="color: grey">({{item.real_sale}}+3)</span>
                                    </div>
                                    <div v-else class="totalSale"><br/></div>
                                    <div>
                                        <span class="allSaleSum">{{item.sale_sum | fixed}} руб.</span>
                                        <span class="pricePerOne">{{item.priceRubSale | fixed}} руб./{{item.measure}}</span>
                                    </div>
                                </td>
                                <td data-label="При интеллектуальном заказе (комплексном) цена составит" class="saleSum noAfter aiField" v-if="manualAICalculated">
                                    <div v-if="item.aiCalculatedPrice != 0" class="totalSale">
                                        -<span v-if="!item.boxAction">{{item.aiCalculatedSale}}</span><span v-else>{{item.aiCalculatedSale + 3}}</span>% <span v-if="item.boxAction" style="color: grey">({{item.aiCalculatedSale}}+3)</span>
                                    </div>
                                    <div v-else class="totalSale"><br/></div>
                                    <div v-if="item.aiCalculatedPrice != 0">
                                        <span class="allSaleSum">{{item.aiCalculatedSum | fixed}} руб.</span>
                                        <span class="pricePerOne">{{item.aiCalculatedPrice | fixed}} руб./{{item.measure}}</span>
                                    </div>
                                    <div v-else></div>
                                </td>
                                <td class="noAfter">
                                    <button class="btn btn-primary" @click="removeItem(0, item.id, item.groupId, item.good)"><i class="las la-trash"></i></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <h3 v-if="!loading && sets.length == 0 && !manualFlag || empty" class="text-center" style="margin-bottom: 240px">Ваша корзина пуста</h3>
                </div>
                <div class="col-md-12" v-if="mode == 1">
                    <div v-if="(sets.length > 0 || manualFlag) && !empty" class="totalEnd">
                        <h3>Общая сумма заказа:</h3>
                        <div class="row justify-content-center">
                            <div class="col-md-9">
                                <table class="table totalTable">
                                    <tbody>
                                    <tr>
                                        <td>Сумма заказа без скидок</td>
                                        <td>{{crm.fullsum | fixed | separate}} руб.</td>
                                    </tr>
                                    <tr>
                                        <td>Ваша Экономия</td>
                                        <td class="red">{{crm.fullsum - crm.saletotalsum | fixed | separate}} руб.</td>
                                    </tr>
                                    <tr v-for="set in sets" v-bind:key="set.id">
                                        <td>
                                            Комплект "{{set.hh}} {{set.hh_add}}"
                                            <span v-if="set.aiCalculatedSale != 0 && !set.full" class="aiField"><br/>При комплексном заказе</span>
                                        </td>
                                        <td>
                                            <span class="red">{{set.sale}}%</span>
                                            <span v-if="set.aiCalculatedSale != 0 && !set.full" class="aiField"><br/>{{set.aiCalculatedSale}}%</span>
                                        </td>
                                    </tr>
                                    <tr v-if="manualFlag && sets[0]">
                                        <td>Комплектующие "Ручной заказ"</td>
                                        <td class="red">{{manualSet.sale}}%</td>
                                    </tr>
                                    <tr class="lastTotal">
                                        <td>Итоговая сумма заказа с персональными скидками</td>
                                        <td>{{crm.saletotalsum | fixed | separate}} руб.</td>
                                    </tr>
                                    </tbody>
                                </table>
<!--                                <div class="aiTotalTable" v-if="AICalculated">-->
<!--                                    <table class="table totalTable">-->
<!--                                        <tbody>-->
<!--                                        <tr class="aiTotal">-->
<!--                                            <td>Если вы сделаете интеллектуальный заказ (комплексный):</td>-->
<!--                                            <td>{{aiTotal | fixed | separate}} руб.</td>-->
<!--                                        </tr>-->
<!--                                        <tr class="aiTotal">-->
<!--                                            <td>Ваша выгода составит:</td>-->
<!--                                            <td>{{crm.saletotalsum - aiTotal | fixed | separate}} руб.</td>-->
<!--                                        </tr>-->
<!--                                        </tbody>-->
<!--                                    </table>-->
<!--                                    <div class="row justify-content-center">-->
<!--                                        <div class="col-md-6" style="padding-bottom: 15px;">-->
<!--&lt;!&ndash;                                            <a href="javascript:" class="btn btn-outline-primary btn-lg btn-block" @click="calcOrder()">Рассчитать интеллектуальный заказ</a>&ndash;&gt;-->
<!--                                            <a href="javascript:" class="btn btn-outline-primary btn-lg btn-block" @click="toConfig()">Сделать интеллектуальный заказ</a>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
                            </div>
                        </div>
                        <!--<div class="row justify-content-center">-->
                            <!--<div class="col-lg-5">-->
                                <!--<a href="/basket" class="btn-primary btn btn-lg btn-block mt-3"><i class="las la-shopping-basket"></i> Перейти в корзину</a>-->
                            <!--</div>-->
                        <!--</div>-->
                    </div>

                    <div v-if="(sets.length > 0 || manualFlag) && !empty " class="row justify-content-center">
                        <div class="col-md-5" style="padding-bottom: 15px;">
                            <router-link to="/accessoriesOrdering" class="btn btn-outline-primary btn-lg btn-block"> Продолжить заведение заказа</router-link>
                        </div>
                    </div>
                    <div v-if="(sets.length > 0 || manualFlag) && !empty" class="row justify-content-center">
                        <div class="col-md-5" style="padding-bottom: 15px;">
<!--                            <a href="#" class="btn btn-outline-primary btn-lg btn-block" @click="$modal.show('warning')"> Оформить заказ</a>-->
                            <a href="#" class="btn btn-outline-primary btn-lg btn-block" @click="checkPrice()"> Оформить заказ</a>
<!--                            <a href="#" class="btn btn-outline-primary btn-lg btn-block" @click="calcOrder()"> Оформить заказ</a>-->
<!--                            <a href="#" class="btn btn-outline-primary btn-lg btn-block" @click="openOrder()"> Оформить заказ</a>-->
                        </div>
                    </div>
                    <div v-if="(sets.length > 0 || manualFlag) && !empty" class="row justify-content-center">
                        <div class="col-md-5" style="padding-bottom: 15px;">
                            <a href="#" class="btn btn-outline-primary btn-lg btn-block" @click="clearBasket()"> Очистить корзину</a>
                        </div>
                    </div>
                    <!--<div class="row justify-content-center" style="margin-bottom: 100px">-->
                        <!--<div class="col-md-5" style="padding-bottom: 40px;">-->
                            <!--<a href="/configurator" class="btn btn-outline-primary btn-lg btn-block"><i class="las la-angle-left"></i> Вернуться в конфигуратор</a>-->
                        <!--</div>-->
                    <!--</div>-->
                </div>

                <div class="col-md-12 preview" v-if="mode == 2 && (rm.itemsStorageRolo.length > 0 || rm.itemsStorageHorizontal.length > 0)">
                    <table class="table" v-if="rm.itemsStorageRolo.length > 0">
                        <tbody>
                        <tr>
                            <td colspan="12" class="text-center">Рулонные шторы RM со склада (габаритный размер)</td>
                        </tr>
                        </tbody>
                        <tbody>
                        <tr class="tableHeader">
                            <td style="border-top: none;">Наименование <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;" colspan="2">Материал <br><i class="las la-angle-down"></i></td>

                            <td style="border-top: none;">Габ-ная ширина изделия, см <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Габ-ная высота изделия, см <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Габаритные размеры упаковки <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Сторона управления <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Намотка ткани <br><i class="las la-angle-down"></i></td>

                            <td style="border-top: none;">Кол-во <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Цена по Прайсу <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Цена со Скидкой <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Удалить <br><i class="las la-angle-down"></i></td>
                        </tr>
                        </tbody>
                        <tbody>
                        <tr class="item" v-for="(item, index) in rm.itemsStorageRolo" v-bind:key="index">
                            <td data-label="Наименование">{{item.data.nameRu}} {{item.data.name}}</td>
                            <td data-label="Материал" class="noAfter">
                                <silentbox-single :src="'https://sale.katris.ru/uploads/images/saleKatrisCatalog/' + item.materials[item.template.material].img+ '.png'" :autoplay="true" :description="item.data.name">
                                    <img :src="'https://sale.katris.ru/uploads/___res_w80_q60/images/saleKatrisCatalog/' + item.materials[item.template.material].img + '.png'" :alt="item.data.name" width="60px" height="45px">
                                </silentbox-single>
                            </td>

                            <td>
                                {{ item.materials[item.template.material].name }}
                            </td>

                            <td data-label="Габ-ная ширина изделия, см ">{{ item.template.gab_width / 10 }}</td>
                            <td data-label="Габ-ная высота изделия, см">{{ item.template.gab_height / 10 }}</td>
                            <td data-label="Габаритные размеры упаковки">{{item.template.packSize}}</td>
                            <td data-label="Сторона управления">
                                <span v-if="item.template.ControlSide == 1">
                                    Левая
                                </span>
                                <span v-else-if="item.template.ControlSide == 2">
                                    Правая
                                </span>
                            </td>
                            <td data-label="Намотка ткани">
                                <span v-if="item.template.BackWrap == 1">
                                    Прямая
                                </span>
                                <span v-else-if="item.template.BackWrap == 2">
                                    Обратная
                                </span>
                            </td>

                            <td data-label="Кол-во">{{item.template.amount}} шт.</td>
                            <td data-label="Цена по Прайсу" class="sum">
                                <div>
                                    <span class="allSum">{{item.template.price | fixed}} руб.</span>
                                    <span class="pricePerOne">{{item.template.price / item.template.amount | fixed}} руб./шт.</span>
                                </div>
                            </td>
                            <td data-label="Цена со Скидкой" class="saleSum">
                                <div v-if="item.template.sale == 0">
                                    <span class="allSaleSum">{{ (item.template.price - (readyMade.basket.totalSale / 100 * item.template.price)) | fixed}} руб.</span>
                                    <span class="pricePerOne">{{(item.template.price - (readyMade.basket.totalSale / 100 * item.template.price)) / item.template.amount | fixed}} руб./шт.</span>
                                </div>
                                <div v-else>
                                    <span class="allSaleSum">{{ (item.template.price - (item.template.sale / 100 * item.template.price)) | fixed}} руб.</span>
                                    <span class="pricePerOne">{{(item.template.price - (item.template.sale / 100 * item.template.price)) / item.template.amount | fixed}} руб./шт.</span>
                                </div>
                            </td>

                            <td class="noAfter">
                                <button class="btn btn-primary" @click="removeItemRM(index, 1)"><i class="las la-trash"></i></button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <table class="table" v-if="rm.itemsStorageHorizontal.length > 0">
                        <tbody>
                        <tr>
                            <td colspan="10" class="text-center">Горизонтальные жалюзи RM картон со склада (габаритный размер)</td>
                        </tr>
                        </tbody>
                        <tbody>
                        <tr class="tableHeader">
                            <td style="border-top: none;">Наименование <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;" colspan="2">Материал <br><i class="las la-angle-down"></i></td>

                            <td style="border-top: none;">Габ-ная ширина изделия, см <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Габ-ная высота изделия, см <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Габаритные размеры упаковки <br><i class="las la-angle-down"></i></td>

                            <td style="border-top: none;">Кол-во <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Цена по Прайсу <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Цена со Скидкой <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Удалить <br><i class="las la-angle-down"></i></td>
                        </tr>
                        </tbody>
                        <tbody>
                        <tr class="item" v-for="(item, index) in rm.itemsStorageHorizontal" v-bind:key="index">
                            <td data-label="Наименование">{{item.data.nameRu}} {{item.data.name}}</td>
                            <td data-label="Материал" class="noAfter">
                                <silentbox-single :src="'https://sale.katris.ru/uploads/images/saleKatrisCatalog/' + item.materials[item.template.material].img+ '.png'" :autoplay="true" :description="item.data.name">
                                    <img :src="'https://sale.katris.ru/uploads/___res_w80_q60/images/saleKatrisCatalog/' + item.materials[item.template.material].img + '.png'" :alt="item.data.name" width="60px" height="45px">
                                </silentbox-single>
                            </td>

                            <td>
                                {{ item.materials[item.template.material].name }}
                            </td>

                            <td data-label="Габ-ная ширина изделия, см ">{{ item.template.gab_width / 10 }}</td>
                            <td data-label="Габ-ная высота изделия, см">{{ item.template.gab_height / 10 }}</td>
                            <td data-label="Габаритные размеры упаковки">{{item.template.packSize}}</td>

                            <td data-label="Кол-во">{{item.template.amount}} шт.</td>
                            <td data-label="Цена по Прайсу" class="sum">
                                <div>
                                    <span class="allSum">{{item.template.price}} руб.</span>
                                    <span class="pricePerOne">{{item.template.price / item.template.amount | fixed}} руб./шт.</span>
                                </div>
                            </td>
                            <td data-label="Цена со Скидкой" class="saleSum">
                                <div v-if="item.template.sale == 0">
                                    <span class="allSaleSum">{{ (item.template.price - (readyMade.basket.totalSale / 100 * item.template.price)) | fixed}} руб.</span>
                                    <span class="pricePerOne">{{(item.template.price - (readyMade.basket.totalSale / 100 * item.template.price)) / item.template.amount | fixed}} руб./шт.</span>
                                </div>
                                <div v-else>
                                    <span class="allSaleSum">{{ (item.template.price - (item.template.sale / 100 * item.template.price)) | fixed}} руб.</span>
                                    <span class="pricePerOne">{{(item.template.price - (item.template.sale / 100 * item.template.price)) / item.template.amount | fixed}} руб./шт.</span>
                                </div>
                            </td>

                            <td class="noAfter">
                                <button class="btn btn-primary" @click="removeItemRM(index, 2)"><i class="las la-trash"></i></button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-md-12" v-if="mode == 2 && (rm.itemsStorageRolo.length > 0 || rm.itemsStorageHorizontal.length > 0)">
                    <div class="totalEnd">
                        <h3>Общая сумма заказа:</h3>
                        <div class="row justify-content-center">
                            <div class="col-md-9">
                                <table class="table totalTable">
                                    <tbody>
                                    <tr>
                                        <td>Сумма заказа без скидок</td>
                                        <td>{{readyMade.basket.totalPrice | fixed | separate}} руб.</td>
                                    </tr>
                                    <tr>
                                        <td>Ваша Экономия</td>
                                        <td class="red">{{readyMade.basket.totalSaleSum | fixed | separate}} руб.</td>
                                    </tr>
                                    <tr class="lastTotal">
                                        <td>Итоговая сумма заказа с персональными скидками</td>
                                        <td>{{readyMade.basket.totalTotal | fixed | separate}} руб.</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div  class="row justify-content-center">
                        <div class="col-md-5" style="padding-bottom: 15px;">
                            <router-link to="/readyMade" class="btn btn-outline-primary btn-lg btn-block"> Продолжить заведение заказа</router-link>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-md-5" style="padding-bottom: 15px;">
                            <a href="#" class="btn btn-outline-primary btn-lg btn-block" @click="prepareOrderRM()"> Оформить заказ</a>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-md-5" style="padding-bottom: 15px;">
                            <a href="#" class="btn btn-outline-primary btn-lg btn-block" @click="clearBasketRM()"> Очистить корзину</a>
                        </div>
                    </div>
                </div>
                <div class="col-md-12" v-else-if="mode == 2 && !loading">
                    <h3 class="text-center" style="margin-bottom: 240px">Ваша корзина пуста</h3>
                </div>

                <div class="col-md-12 preview" v-if="mode == 3 && (rm.itemsRolo.length > 0 || rm.itemsHorizontal.length > 0 || rm.itemsHorizontalBlister.length > 0 || rm.itemsCorniceVertical.length > 0 || rm.itemsMaterialVertical.length > 0 || rm.itemsMatRolo.length > 0)">
                    <table class="table" v-if="rm.itemsRolo.length > 0">
                        <tbody>
                        <tr>
                            <td colspan="12" class="text-center">Рулонные шторы RM (габаритный размер)</td>
                        </tr>
                        </tbody>
                        <tbody>
                        <tr class="tableHeader">
                            <td style="border-top: none;">Наименование <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;" colspan="2">Материал <br><i class="las la-angle-down"></i></td>

                            <td style="border-top: none;">Габ-ная ширина изделия, см <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Габ-ная высота изделия, см <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Габаритные размеры упаковки <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Сторона управления <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Намотка ткани <br><i class="las la-angle-down"></i></td>

                            <td style="border-top: none;">Кол-во <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Цена по Прайсу <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Цена со Скидкой <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Удалить <br><i class="las la-angle-down"></i></td>
                        </tr>
                        </tbody>
                        <tbody>
                        <tr class="item" v-for="(item, index) in rm.itemsRolo" v-bind:key="index">
                            <td data-label="Наименование">{{item.data.nameRu}} {{item.data.name}}</td>
                            <td data-label="Материал" class="noAfter">
                                <silentbox-single :src="'https://sale.katris.ru/uploads/images/saleKatrisCatalog/' + item.materials[item.template.material].img+ '.png'" :autoplay="true" :description="item.data.name">
                                    <img :src="'https://sale.katris.ru/uploads/___res_w80_q60/images/saleKatrisCatalog/' + item.materials[item.template.material].img + '.png'" :alt="item.data.name" width="60px" height="45px">
                                </silentbox-single>
                            </td>

                            <td>
                                {{ item.materials[item.template.material].name }}
                            </td>

                            <td data-label="Габ-ная ширина изделия, см ">{{ item.template.gab_width / 10 }}</td>
                            <td data-label="Габ-ная высота изделия, см">{{ item.template.gab_height / 10 }}</td>
                            <td data-label="Габаритные размеры упаковки">{{item.template.packSize}}</td>
                            <td data-label="Сторона управления">
                                <span v-if="item.template.ControlSide == 1">
                                    Левая
                                </span>
                                <span v-else-if="item.template.ControlSide == 2">
                                    Правая
                                </span>
                            </td>
                            <td data-label="Намотка ткани">
                                <span v-if="item.template.BackWrap == 1">
                                    Прямая
                                </span>
                                <span v-else-if="item.template.BackWrap == 2">
                                    Обратная
                                </span>
                            </td>

                            <td data-label="Кол-во">{{item.template.amount}} шт.</td>
                            <td data-label="Цена по Прайсу" class="sum">
                                <div>
                                    <span class="allSum">{{item.template.price | fixed}} руб.</span>
                                    <span class="pricePerOne">{{item.template.price / item.template.amount | fixed}} руб./шт.</span>
                                </div>
                            </td>
                            <td data-label="Цена со Скидкой" class="saleSum">
                                <div v-if="item.template.sale == 0">
                                    <span class="allSaleSum">{{ (item.template.price - (readyMade.basket.totalSale / 100 * item.template.price)) | fixed}} руб.</span>
                                    <span class="pricePerOne">{{(item.template.price - (readyMade.basket.totalSale / 100 * item.template.price)) / item.template.amount | fixed}} руб./шт.</span>
                                </div>
                                <div v-else>
                                    <span class="allSaleSum">{{ (item.template.price - (item.template.sale / 100 * item.template.price)) | fixed}} руб.</span>
                                    <span class="pricePerOne">{{(item.template.price - (item.template.sale / 100 * item.template.price)) / item.template.amount | fixed}} руб./шт.</span>
                                </div>
                            </td>

                            <td class="noAfter">
                                <button class="btn btn-primary" @click="removeItemRM(index, 3)"><i class="las la-trash"></i></button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <table class="table" v-if="rm.itemsHorizontal.length > 0">
                        <tbody>
                        <tr>
                            <td colspan="10" class="text-center">Горизонтальные жалюзи RM картон под заказ (габаритный размер)</td>
                        </tr>
                        </tbody>
                        <tbody>
                        <tr class="tableHeader">
                            <td style="border-top: none;">Наименование <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;" colspan="2">Материал <br><i class="las la-angle-down"></i></td>

                            <td style="border-top: none;">Габ-ная ширина изделия, см <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Габ-ная высота изделия, см <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Габаритные размеры упаковки <br><i class="las la-angle-down"></i></td>

                            <td style="border-top: none;">Кол-во <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Цена по Прайсу <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Цена со Скидкой <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Удалить <br><i class="las la-angle-down"></i></td>
                        </tr>
                        </tbody>
                        <tbody>
                        <tr class="item" v-for="(item, index) in rm.itemsStorageHorizontal" v-bind:key="index">
                            <td data-label="Наименование">{{item.data.nameRu}} {{item.data.name}}</td>
                            <td data-label="Материал" class="noAfter">
                                <silentbox-single :src="'https://sale.katris.ru/uploads/images/saleKatrisCatalog/' + item.materials[item.template.material].img+ '.png'" :autoplay="true" :description="item.data.name">
                                    <img :src="'https://sale.katris.ru/uploads/___res_w80_q60/images/saleKatrisCatalog/' + item.materials[item.template.material].img + '.png'" :alt="item.data.name" width="60px" height="45px">
                                </silentbox-single>
                            </td>

                            <td>
                                {{ item.materials[item.template.material].name }}
                            </td>

                            <td data-label="Габ-ная ширина изделия, см ">{{ item.template.gab_width / 10 }}</td>
                            <td data-label="Габ-ная высота изделия, см">{{ item.template.gab_height / 10 }}</td>
                            <td data-label="Габаритные размеры упаковки">{{item.template.packSize}}</td>

                            <td data-label="Кол-во">{{item.template.amount}} шт.</td>
                            <td data-label="Цена по Прайсу" class="sum">
                                <div>
                                    <span class="allSum">{{item.template.price}} руб.</span>
                                    <span class="pricePerOne">{{item.template.price / item.template.amount | fixed}} руб./шт.</span>
                                </div>
                            </td>
                            <td data-label="Цена со Скидкой" class="saleSum">
                                <div v-if="item.template.sale == 0">
                                    <span class="allSaleSum">{{ (item.template.price - (readyMade.basket.totalSale / 100 * item.template.price)) | fixed}} руб.</span>
                                    <span class="pricePerOne">{{(item.template.price - (readyMade.basket.totalSale / 100 * item.template.price)) / item.template.amount | fixed}} руб./шт.</span>
                                </div>
                                <div v-else>
                                    <span class="allSaleSum">{{ (item.template.price - (item.template.sale / 100 * item.template.price)) | fixed}} руб.</span>
                                    <span class="pricePerOne">{{(item.template.price - (item.template.sale / 100 * item.template.price)) / item.template.amount | fixed}} руб./шт.</span>
                                </div>
                            </td>

                            <td class="noAfter">
                                <button class="btn btn-primary" @click="removeItemRM(index, 4)"><i class="las la-trash"></i></button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <table class="table" v-if="rm.itemsHorizontalBlister.length > 0">
                        <tbody>
                        <tr>
                            <td colspan="10" class="text-center">Горизонтальные жалюзи RM блистер под заказ (габаритный размер)</td>
                        </tr>
                        </tbody>
                        <tbody>
                        <tr class="tableHeader">
                            <td style="border-top: none;">Наименование <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;" colspan="2">Материал <br><i class="las la-angle-down"></i></td>

                            <td style="border-top: none;">Габ-ная ширина изделия, см <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Габ-ная высота изделия, см <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Габаритные размеры упаковки <br><i class="las la-angle-down"></i></td>

                            <td style="border-top: none;">Кол-во <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Цена по Прайсу <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Цена со Скидкой <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Удалить <br><i class="las la-angle-down"></i></td>
                        </tr>
                        </tbody>
                        <tbody>
                        <tr class="item" v-for="(item, index) in rm.itemsHorizontalBlister" v-bind:key="index">
                            <td data-label="Наименование">{{item.data.nameRu}} {{item.data.name}}</td>
                            <td data-label="Материал" class="noAfter">
                                <silentbox-single :src="'https://sale.katris.ru/uploads/images/saleKatrisCatalog/' + item.materials[item.template.material].img+ '.png'" :autoplay="true" :description="item.data.name">
                                    <img :src="'https://sale.katris.ru/uploads/___res_w80_q60/images/saleKatrisCatalog/' + item.materials[item.template.material].img + '.png'" :alt="item.data.name" width="60px" height="45px">
                                </silentbox-single>

                            </td>
                            <td>

                                {{ item.materials[item.template.material].name }}
                            </td>

                            <td data-label="Габ-ная ширина изделия, см ">{{ item.template.gab_width / 10 }}</td>
                            <td data-label="Габ-ная высота изделия, см">{{ item.template.gab_height / 10 }}</td>
                            <td data-label="Габаритные размеры упаковки">{{item.template.packSize}}</td>

                            <td data-label="Кол-во">{{item.template.amount}} шт.</td>
                            <td data-label="Цена по Прайсу" class="sum">
                                <div>
                                    <span class="allSum">{{item.template.price}} руб.</span>
                                    <span class="pricePerOne">{{item.template.price / item.template.amount | fixed}} руб./шт.</span>
                                </div>
                            </td>
                            <td data-label="Цена со Скидкой" class="saleSum">
                                <div v-if="item.template.sale == 0">
                                    <span class="allSaleSum">{{ (item.template.price - (readyMade.basket.totalSale / 100 * item.template.price)) | fixed}} руб.</span>
                                    <span class="pricePerOne">{{(item.template.price - (readyMade.basket.totalSale / 100 * item.template.price)) / item.template.amount | fixed}} руб./шт.</span>
                                </div>
                                <div v-else>
                                    <span class="allSaleSum">{{ (item.template.price - (item.template.sale / 100 * item.template.price)) | fixed}} руб.</span>
                                    <span class="pricePerOne">{{(item.template.price - (item.template.sale / 100 * item.template.price)) / item.template.amount | fixed}} руб./шт.</span>
                                </div>
                            </td>

                            <td class="noAfter">
                                <button class="btn btn-primary" @click="removeItemRM(index, 5)"><i class="las la-trash"></i></button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <table class="table" v-if="rm.itemsCorniceVertical.length > 0">
                        <tbody>
                        <tr>
                            <td colspan="9" class="text-center">Вертикальные жалюзи RM карнизы под заказ</td>
                        </tr>
                        </tbody>
                        <tbody>
                        <tr class="tableHeader">
                            <td style="border-top: none;">Наименование <br><i class="las la-angle-down"></i></td>

                            <td style="border-top: none;">Тип крепления <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Тип раздвижки ламелей <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Длина <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Габаритные размеры упаковки <br><i class="las la-angle-down"></i></td>

                            <td style="border-top: none;">Кол-во <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Цена по Прайсу <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Цена со Скидкой <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Удалить <br><i class="las la-angle-down"></i></td>
                        </tr>
                        </tbody>
                        <tbody>
                        <tr class="item" v-for="(item, index) in rm.itemsCorniceVertical" v-bind:key="index">
                            <td data-label="Наименование">{{item.data.nameRu}} {{item.data.name}}</td>

                            <td data-label="Тип крепления">
                                <span v-if="item.template.mountType == 1">Потолок</span>
                                <span v-else-if="item.template.mountType == 2">Стена</span>
                                <span v-else-if="item.template.mountType == 3">Стена с удлинителем</span>
                            </td>
                            <td data-label="Тип раздвижки ламелей">
                                <span v-if="item.template.drive == 1">К механизму управления</span>
                                <span v-else-if="item.template.drive == 2">От центра в две стороны</span>
                                <span v-else-if="item.template.drive == 3">От механизма управления</span>
                            </td>
                            <td data-label="Длина">{{item.template.corniceSize}}</td>

                            <td data-label="Габаритные размеры упаковки">{{item.template.packSize}}</td>

                            <td data-label="Кол-во">{{item.template.amount}} шт.</td>
                            <td data-label="Цена по Прайсу" class="sum">
                                <div>
                                    <span class="allSum">{{item.template.price | fixed}} руб.</span>
                                    <span class="pricePerOne">{{item.template.price / item.template.amount | fixed}} руб./шт.</span>
                                </div>
                            </td>
                            <td data-label="Цена со Скидкой" class="saleSum">
                                <div v-if="item.template.sale == 0">
                                    <span class="allSaleSum">{{ (item.template.price - (readyMade.basket.totalSale / 100 * item.template.price)) | fixed}} руб.</span>
                                    <span class="pricePerOne">{{(item.template.price - (readyMade.basket.totalSale / 100 * item.template.price)) / item.template.amount | fixed}} руб./шт.</span>
                                </div>
                                <div v-else>
                                    <span class="allSaleSum">{{ (item.template.price - (item.template.sale / 100 * item.template.price)) | fixed}} руб.</span>
                                    <span class="pricePerOne">{{(item.template.price - (item.template.sale / 100 * item.template.price)) / item.template.amount | fixed}} руб./шт.</span>
                                </div>
                            </td>

                            <td class="noAfter">
                                <button class="btn btn-primary" @click="removeItemRM(index, 6)"><i class="las la-trash"></i></button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <table class="table" v-if="rm.itemsMaterialVertical.length > 0">
                        <tbody>
                        <tr>
                            <td colspan="10" class="text-center">Вертикальные жалюзи RM ткани под заказ</td>
                        </tr>
                        </tbody>
                        <tbody>
                        <tr class="tableHeader">
                            <td style="border-top: none;">Наименование <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;" colspan="2">Материал <br><i class="las la-angle-down"></i></td>

                            <td style="border-top: none;">Количество ламелей <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Габ-ная высота изделия, см <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Габаритные размеры упаковки <br><i class="las la-angle-down"></i></td>

                            <td style="border-top: none;">Кол-во <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Цена по Прайсу <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Цена со Скидкой <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Удалить <br><i class="las la-angle-down"></i></td>
                        </tr>
                        </tbody>
                        <tbody>
                        <tr class="item" v-for="(item, index) in rm.itemsMaterialVertical" v-bind:key="index">
                            <td data-label="Наименование">{{item.data.nameRu}} {{item.data.name}}</td>
                            <td data-label="Материал" class="noAfter">
                                <silentbox-single :src="'https://sale.katris.ru/uploads/images/saleKatrisCatalog/' + item.materials[item.template.material].img+ '.png'" :autoplay="true" :description="item.data.name">
                                    <img :src="'https://sale.katris.ru/uploads/___res_w80_q60/images/saleKatrisCatalog/' + item.materials[item.template.material].img + '.png'" :alt="item.data.name" width="60px" height="45px">
                                </silentbox-single>
                            </td>

                            <td>
                                {{ item.materials[item.template.material].name }}
                            </td>

                            <td data-label="Количество ламелей">{{ item.template.lamels}}</td>
                            <td data-label="Габ-ная высота изделия, см">{{ item.template.height }}</td>
                            <td data-label="Габаритные размеры упаковки">{{item.template.packSize}}</td>

                            <td data-label="Кол-во">{{item.template.amount}} шт.</td>
                            <td data-label="Цена по Прайсу" class="sum">
                                <div>
                                    <span class="allSum">{{item.template.price | fixed}} руб.</span>
                                    <span class="pricePerOne">{{item.template.price / item.template.amount | fixed}} руб./шт.</span>
                                </div>
                            </td>
                            <td data-label="Цена со Скидкой" class="saleSum">
                                <div v-if="item.template.sale == 0">
                                    <span class="allSaleSum">{{ (item.template.price - (readyMade.basket.totalSale / 100 * item.template.price)) | fixed}} руб.</span>
                                    <span class="pricePerOne">{{(item.template.price - (readyMade.basket.totalSale / 100 * item.template.price)) / item.template.amount | fixed}} руб./шт.</span>
                                </div>
                                <div v-else>
                                    <span class="allSaleSum">{{ (item.template.price - (item.template.sale / 100 * item.template.price)) | fixed}} руб.</span>
                                    <span class="pricePerOne">{{(item.template.price - (item.template.sale / 100 * item.template.price)) / item.template.amount | fixed}} руб./шт.</span>
                                </div>
                            </td>

                            <td class="noAfter">
                                <button class="btn btn-primary" @click="removeItemRM(index, 7)"><i class="las la-trash"></i></button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <table class="table" v-if="rm.itemsMatRolo.length > 0">
                        <tbody>
                        <tr>
                            <td colspan="11" class="text-center">Рулонные шторы RM (размер по ткани)</td>
                        </tr>
                        </tbody>
                        <tbody>
                        <tr class="tableHeader">
                            <td style="border-top: none;">Наименование <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;" colspan="2">Материал <br><i class="las la-angle-down"></i></td>

                            <td style="border-top: none;">Габ-ная ширина изделия, см <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Габ-ная высота изделия, см <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Сторона управления <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Намотка ткани <br><i class="las la-angle-down"></i></td>

                            <td style="border-top: none;">Кол-во <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Цена по Прайсу <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Цена со Скидкой <br><i class="las la-angle-down"></i></td>
                            <td style="border-top: none;">Удалить <br><i class="las la-angle-down"></i></td>
                        </tr>
                        </tbody>
                        <tbody>
                        <tr class="item" v-for="(item, index) in rm.itemsMatRolo" v-bind:key="index">
                            <td data-label="Наименование">{{item.data.nameRu}} {{item.data.name}}</td>
                            <td data-label="Материал" class="noAfter">
                                <silentbox-single :src="'https://sale.katris.ru/uploads/images/saleKatrisCatalog/' + item.materials[item.template.material].img+ '.png'" :autoplay="true" :description="item.data.name">
                                    <img :src="'https://sale.katris.ru/uploads/___res_w80_q60/images/saleKatrisCatalog/' + item.materials[item.template.material].img + '.png'" :alt="item.data.name" width="60px" height="45px">
                                </silentbox-single>
                            </td>

                            <td>
                                {{ item.materials[item.template.material].name }}
                            </td>

                            <td data-label="Габ-ная ширина изделия, см ">{{ item.template.gab_width / 10 }}</td>
                            <td data-label="Габ-ная высота изделия, см">{{ item.template.gab_height / 10 }}</td>
                            <td data-label="Сторона управления">
                                <span v-if="item.template.ControlSide == 1">
                                    Левая
                                </span>
                                <span v-else-if="item.template.ControlSide == 2">
                                    Правая
                                </span>
                            </td>
                            <td data-label="Намотка ткани">
                                <span v-if="item.template.BackWrap == 1">
                                    Прямая
                                </span>
                                <span v-else-if="item.template.BackWrap == 2">
                                    Обратная
                                </span>
                            </td>

                            <td data-label="Кол-во">{{item.template.amount}} шт.</td>
                            <td data-label="Цена по Прайсу" class="sum">
                                <div>
                                    <span class="allSum">{{item.template.price | fixed}} руб.</span>
                                    <span class="pricePerOne">{{item.template.price / item.template.amount | fixed}} руб./шт.</span>
                                </div>
                            </td>
                            <td data-label="Цена со Скидкой" class="saleSum">
                                <div v-if="item.template.sale == 0">
                                    <span class="allSaleSum">{{ (item.template.price - (readyMade.basket.totalSale / 100 * item.template.price)) | fixed}} руб.</span>
                                    <span class="pricePerOne">{{(item.template.price - (readyMade.basket.totalSale / 100 * item.template.price)) / item.template.amount | fixed}} руб./шт.</span>
                                </div>
                                <div v-else>
                                    <span class="allSaleSum">{{ (item.template.price - (item.template.sale / 100 * item.template.price)) | fixed}} руб.</span>
                                    <span class="pricePerOne">{{(item.template.price - (item.template.sale / 100 * item.template.price)) / item.template.amount | fixed}} руб./шт.</span>
                                </div>
                            </td>

                            <td class="noAfter">
                                <button class="btn btn-primary" @click="removeItemRM(index, 8)"><i class="las la-trash"></i></button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-md-12" v-if="mode == 3 && (rm.itemsRolo.length > 0 || rm.itemsHorizontal.length > 0 || rm.itemsHorizontalBlister.length > 0 || rm.itemsCorniceVertical.length > 0 || rm.itemsMaterialVertical.length > 0 || rm.itemsMatRolo.length > 0)">
                    <div class="totalEnd">
                        <h3>Общая сумма заказа:</h3>
                        <div class="row justify-content-center">
                            <div class="col-md-9">
                                <table class="table totalTable">
                                    <tbody>
                                    <tr>
                                        <td>Сумма заказа без скидок</td>
                                        <td>{{readyMade.basket.totalPrice | fixed | separate}} руб.</td>
                                    </tr>
                                    <tr>
                                        <td>Ваша Экономия</td>
                                        <td class="red">{{readyMade.basket.totalSaleSum | fixed | separate}} руб.</td>
                                    </tr>
                                    <tr class="lastTotal">
                                        <td>Итоговая сумма заказа с персональными скидками</td>
                                        <td>{{readyMade.basket.totalTotal | fixed | separate}} руб.</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div  class="row justify-content-center">
                        <div class="col-md-5" style="padding-bottom: 15px;">
                            <router-link to="/readyMade" class="btn btn-outline-primary btn-lg btn-block"> Продолжить заведение заказа</router-link>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-md-5" style="padding-bottom: 15px;">
                            <a href="#" class="btn btn-outline-primary btn-lg btn-block" @click="prepareOrderRM()"> Оформить заказ</a>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-md-5" style="padding-bottom: 15px;">
                            <a href="#" class="btn btn-outline-primary btn-lg btn-block" @click="clearBasketRM()"> Очистить корзину</a>
                        </div>
                    </div>
                </div>
                <div class="col-md-12" v-else-if="mode == 3 && !loading">
                    <h3 class="text-center" style="margin-bottom: 240px">Ваша корзина пуста</h3>
                </div>

                <modal name="order" :min-width="200"
                       :min-height="200"
                       :adaptive="true"
                       :scrollable="true"
                       :reset="true"
                       width="600px"
                       height="auto">
                    <div style="padding: 20px">
                        <p>Выберите Плательщика:</p>
                        <select v-model="orderPayerID" class="form-control">
                            <option disabled="disabled" value="-1">Не выбрано</option>
                            <option v-for="payer in payers" :value="payer.id" v-bind:key="payer.id">{{payer.name}}</option>
                        </select>
                        <br/>
                        <p>Выберите способ доставки:</p>
                        <select class="form-control" v-model="orderDeliveryID">
                            <option v-for="(delivery, index) in deliveryTypes" :value="delivery['id']" v-bind:key="index">{{delivery['name']}}</option>
                        </select>
                        <br/>
                        <p>Укажите свой номер заказа:</p>
                        <input class="form-control" v-model="orderNumber" type="text" maxlength="10">
                        <hr>
                        <div class="row">
                            <div class="col-md-6">
                                <input v-if="!orderSent" type="button" class="btn btn-primary btn-block" value="ОТПРАВИТЬ ЗАКАЗ" @click="sendOrder()" />
                                <input v-else type="button" class="btn btn-secondary btn-block" value="ОТПРАВИТЬ ЗАКАЗ" disabled />
                            </div>
                            <div class="col-md-6">
                                <input type="button" class="btn btn-primary btn-block mt-3 mt-sm-3 mt-md-0 mt-lg-0" value="ОТМЕНА" @click="$modal.hide('order')" />
                            </div>
                        </div>
                    </div>
                </modal>

                <modal name="changes" :min-width="200"
                       :min-height="200"
                       :adaptive="true"
                       :scrollable="true"
                       :reset="true"
                       width="600px"
                       height="auto">
                    <div style="padding: 20px">
                        <h2>В заказе произошли изменения:</h2>

                        <div v-if="changes.changed[0]">
                            <p><b>Изменилась цена или скидка на следующие позиции:</b></p>

                            <div v-for="(item, index) in changes.changed" v-bind:key="index">
                                <p>{{item.name}} ({{item.setName}})</p>
                            </div>
                        </div>

                        <div v-if="changes.removed[0]">
                            <p><b>Следующие позиции были удалены (нет в наличии):</b></p>

                            <div v-for="(item, index) in changes.removed" v-bind:key="index">
                                <p>{{item.name}} ({{item.setName}})</p>
                            </div>

                            <p><b>Это не влияет на получение скидки</b></p>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <input type="button" class="btn btn-primary btn-block" value="Закрыть" @click="$modal.hide('changes')" />
                            </div>
                        </div>
                    </div>
                </modal>

                <modal name="changes2" :min-width="200"
                       :min-height="200"
                       :adaptive="true"
                       :scrollable="true"
                       :reset="true"
                       width="600px"
                       height="auto">
                    <div style="padding: 20px">
                        <h2>В заказе произошли изменения:</h2>

                        <div v-if="changes.changed[0]">
                            <p><b>Изменилась цена или скидка на следующие позиции:</b></p>

                            <div v-for="(item, index) in changes.changed" v-bind:key="index">
                                <p>{{item.name}} ({{item.setName}})</p>
                            </div>
                        </div>

                        <div v-if="changes.removed[0]">
                            <p><b>Следующие позиции были удалены (нет в наличии):</b></p>

                            <div v-for="(item, index) in changes.removed" v-bind:key="index">
                                <p>{{item.name}} ({{item.setName}})</p>
                            </div>

                            <p><b>Это не влияет на получение скидки</b></p>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <input type="button" class="btn btn-primary btn-block mb-2" value="Продолжить оформление" @click="calcOrder()" />
                            </div>
                            <div class="col-md-12">
                                <input type="button" class="btn btn-primary btn-block" value="Закрыть" @click="$modal.hide('changes2')" />
                            </div>
                        </div>
                    </div>
                </modal>

                <modal name="calcOrder" :min-width="200"
                       :min-height="200"
                       :adaptive="true"
                       :scrollable="true"
                       :reset="true"
                       width="600px"
                       height="auto">
                    <div style="padding: 20px">
                        <div class="row">
                            <div class="col-md-12">
                                <h2 v-if="manualFlag || calculatedSets[0]">Сделайте комплексный заказ для получения скидки</h2>
                                <div v-if="manualFlag" class="aiTotalTable">
                                    <table class="table totalTable">
                                        <tbody>
                                        <tr class="aiTotal">
                                            <td class="pb-0">
                                                Если вы сделаете интеллектуальный заказ (комплексный),<br/> то его сумма с учетом средней скидки <b style="color: blue">{{totalPercents | fixed}}%</b> составит:
                                            </td>
                                            <td class="pb-0">
                                                {{calcOrderFullSum | fixed | separate}} руб.<br/>
                                            </td>
                                        </tr>
                                        <tr class="aiTotal">
                                            <td class="pt-0 font-weight-light">
                                                Сумма не комплексного заказа у Вас в корзине:
                                            </td>
                                            <td class="pt-0 font-weight-light">
                                                {{crm.saletotalsum | fixed | separate}} руб.
                                            </td>
                                        </tr>
                                        <tr class="aiTotal border-top">
                                            <td class="pb-0">
                                                Ваша выгода при комплексном заказе:
                                            </td>
                                            <td class="pb-0" style="color: blue">
                                                {{calcOrderSaleSum | fixed | separate}} руб.
                                            </td>
                                        </tr>
                                        <tr class="aiTotal">
                                            <td class="pt-0 font-weight-light">
                                                Ваша выгода при не комплексном заказе:
                                            </td>
                                            <td class="pt-0 font-weight-light">
                                                {{crm.fullsum - crm.saletotalsum | fixed | separate}} руб.
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <button v-if="!orderHint" type="button" class="btn btn-primary btn-lg btn-block mb-3 mt-3 triangle" style="background-color: #83beff; border-color: #83beff" @click="orderHint = true">
                                    Подробнее <i class="las la-angle-down"></i>
                                </button>
                                <div v-if="orderHint" class="orderHintBlock mt-3 mb-3">
                                    <div v-if="manualFlag || calculatedSets[0]">
                                        <button type="button" class="btn btn-primary btn-lg btn-block triangle" style="background-color: #83beff; border-color: #83beff; border-radius: 29px 29px 0px 0px" @click="orderHint = false">
                                            Подробнее <i class="las la-angle-up"></i>
                                        </button>
                                        <div v-for="(set, index) in calculatedSets" v-bind:key="index">
                                            <h3>Комплект: "{{set.hh}} {{set.hh_add}}"</h3>
                                            <table class="table" v-if="!set.addedInConfig && !set.addedInBasket">
                                                <thead>
                                                    <tr>
                                                        <td>Наименование</td>
                                                        <td>Количество</td>
                                                        <td>Сумма со скидкой</td>
                                                    </tr>
                                                </thead>
                                                <tbody v-for="(group, index) in set.groups" v-bind:key="index">
                                                    <tr v-for="(item, index) in group.items" v-bind:key="index">
                                                        <td>{{item.name}} <span v-if="item.inBusket"><b style="color: blue">(сейчас в корзине)</b></span></td>
                                                        <td>{{item.count}}</td>
                                                        <td>{{item.sale_sum}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                            <div class="row mt-2 mb-2" v-if="!set.addedInConfig">
                                                <div class="col-md-2"></div>
                                                <div class="col-md-8">
                                                    <table class="table">
                                                        <tr>
                                                            <td>Сумма со скидкой:</td>
                                                            <td>{{set.saletotalsum}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Процент скидки:</td>
                                                            <td>{{set.sale}}</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div style="padding: 5px;">
                                                        <input v-if="!set.addedInConfig && !set.addedInBasket" type="button" class="btn btn-primary btn-block" style="background-color: #83beff; border-color: #83beff" value="Добавить комплект в интеллектуальный заказ" @click="addCalculatedSet(set, 0)" />
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div style="padding: 5px;">
                                                        <input v-if="!set.addedInConfig && !set.addedInBasket" type="button" class="btn btn-primary btn-block" style="background-color: #83beff; border-color: #83beff" value="Добавить комплект в корзину" @click="addCalculatedSet(set, 1)" />
                                                    </div>
                                                </div>
                                            </div>
                                            <p class="mb-3 text-center" v-if="set.addedInConfig">Комплект добавлен в интеллектуальный заказ.</p>
                                            <p class="mb-3 text-center" v-if="set.addedInBasket">Комплект добавлен в корзину.</p>
                                        </div>
                                        <button type="button" class="btn btn-outline-primary btn-lg btn-block blockClose" style="" @click="orderHint = false">
                                            Свернуть <i class="las la-angle-up"></i>
                                        </button>
                                    </div>
                                </div>

<!--                                <h2 v-if="calcOrderSetComplexFix">Следующие комплекты можно дополнить до комплексного:</h2>-->
<!--                                <div v-for="(set, index) in notFullSets" v-bind:key="index">-->
<!--                                    <h3 class="text-center m-1 p-1">Комплект: "{{set.hh}} {{set.hh_add}}"</h3>-->

<!--                                    <div v-if="!set.full" class="text-center mb-2">Заказ не комплексный. <br/>Добавить недостающие комплектующие для увеличения скидки,<br/> которая предоставляется при комплексном заказе?</div>-->

<!--                                    <input v-if="!set.full" type="button" class="btn btn-primary btn-block mb-3" value="Добавить недостающие комплектующие" @click="fixSetComplex(set)" />-->

<!--                                    <div v-if="set.recalcFlag" class="text-center">-->
<!--                                        Заказ <span v-if="!set.full">не</span> комплексный на ваше расчётное количество <span v-if="!set.properCalcMeters">изделий</span><span v-else>метров</span>.<br/>-->
<!--                                        При этом, количество комплектующих в заказе:<br/>-->
<!--                                        <span v-if="set.properCalcItem">• {{set.properCalcItem.name}} = {{set.properCalcItem.count}} {{set.properCalcItem.measure}}</span><br/>-->
<!--                                        предназначено для сборки {{set.properCalc}} <span v-if="!set.properCalcMeters">изделий</span><span v-else>метров</span>, что больше расчетного количества.<br/>-->
<!--                                        Пересчитать заказ с {{set.properCalcOriginal}} до {{set.properCalc}} <span v-if="!set.properCalcMeters">изделий</span><span v-else>метров</span>?-->
<!--                                    </div>-->

<!--                                    <input v-if="set.recalcFlag" type="button" class="btn btn-primary btn-block mb-3" value="Пересчитать" @click="fixPartsCount(set)" />-->


<!--                                </div>-->

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <router-link to="/configurator" v-if="gotoConfig" class="btn btn-primary btn-block">Перейти в интеллектуальный заказ</router-link>
                                <a href="javascript:" class="btn btn-primary btn-block" @click="openOrder()">Продолжить оформление</a>
                                <input type="button" class="btn btn-primary btn-block" value="Закрыть" @click="$modal.hide('calcOrder')" />
                            </div>
                        </div>
                    </div>
                </modal>

                <modal name="calcOrder2" :min-width="200"
                       :min-height="200"
                       :adaptive="true"
                       :scrollable="true"
                       :reset="true"
                       width="600px"
                       height="auto">
                    <div style="padding: 20px">
                        <div class="row">
                            <div class="col-md-12">
                                <h2>Следующие товары, добавленные вручную, можно перенести в комплект:</h2>

                                <table class="table">
                                    <thead>
                                    <tr>
                                        <td>Наименование</td>
                                        <td>Количество</td>
                                        <td>Сумма со скидкой</td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in addFromManualToAIArray" v-bind:key="index">
                                            <td>{{item.name}}</td>
                                            <td>{{item.count}}</td>
                                            <td>{{item.sale_sum}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <input type="button" class="btn btn-primary btn-block" value="Перенести" @click="manualToAI(operatingSet)" />
                            </div>
                            <div class="col-md-6">
                                <input type="button" class="btn btn-primary btn-block" value="Продолжить" @click="continueOrderFix(operatingSet)" />
                            </div>
                        </div>
                    </div>
                </modal>

                <div class="notice" v-bind:class="{active: deleted}">
                    <p>Комплект удален из корзины.</p>
                    <p>Расчет комплекта перемещен обратно в Интеллектуальный заказ.</p>
                </div>

                <modal name="loading" :min-width="200"
                       :min-height="200"
                       :adaptive="true"
                       :scrollable="true"
                       :reset="true"
                       :backdrop="false"
                       width="600px"
                       height="auto">
                    <div style="padding: 20px">
                        <div class="row">
                            <div class="col-md-12">
                                <h2>Проверка</h2>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <img src="../assets/img/loader.gif" alt="Загрузка" />
                            </div>
                        </div>
                    </div>
                </modal>

                <modal name="warning" :min-width="200"
                       :min-height="200"
                       :adaptive="true"
                       :scrollable="true"
                       :reset="true"
                       :backdrop="false"
                       width="600px"
                       height="auto">
                    <div style="padding: 20px">
                        <div class="row">
                            <div class="col-md-12">
                                <h2>Условия оплаты</h2>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <p class="font-weight-bold">Уважаемые Партнеры!</p>

                                <p>Информируем вас, что в связи со сложившейся экономической ситуацией, связанной с высокой волатильностью рубля, мы временно переходим на <b>100% предоплату</b> заказов.</p>

                                <p>Счет на оплату при этом действует <b>1 (один)</b> банковский день.</p>

                                <p>Текущий курс компании узнавайте в личных кабинетах.</p>

                                <p>Просим вас с пониманием отнестись к данной ситуации. Благодарим за сотрудничество.</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <input type="button" class="btn btn-primary btn-block" value="Продолжить" @click="checkPrice()" />
                            </div>
                        </div>
                    </div>
                </modal>

                <modal name="orderRM" :min-height="200"
                       :min-width="200"
                       :reset="true"
                       :scrollable="true"
                       height="auto"
                       :adaptive="true"
                       width="600px">
                    <div style="padding: 20px">
                        <p>Выберите Плательщика:</p>
                        <select v-model="orderPayerID" class="form-control">
                            <option disabled="disabled" value="-1">Не выбрано</option>
                            <option v-for="payer in payers" v-bind:key="payer.id" :value="payer.id">{{ payer.name }}</option>
                        </select>
                        <br>
                        <p>Выберите способ доставки:</p>
                        <select v-model="orderDeliveryID" class="form-control">
                            <option v-for="(delivery, index) in deliveryTypes" v-bind:key="index" :value="delivery['id']">
                                {{ delivery['name'] }}
                            </option>
                        </select>
                        <br>
                        <p>Укажите свой номер заказа:</p>
                        <input v-model="orderNumber" class="form-control" maxlength="10" type="text">
                        <hr>
                        <div class="row">
                            <div class="col-md-6">
                                <input v-if="!orderSent" class="btn btn-primary btn-block" type="button" value="ОТПРАВИТЬ ЗАКАЗ" @click="sendOrderRM()"/>
                                <input v-else class="btn btn-secondary btn-block" disabled type="button" value="ОТПРАВИТЬ ЗАКАЗ"/>
                            </div>
                            <div class="col-md-6">
                                <input class="btn btn-primary btn-block mt-3 mt-sm-3 mt-md-0 mt-lg-0" type="button" value="ОТМЕНА" @click="$modal.hide('orderRM')"/>
                            </div>
                        </div>
                    </div>
                </modal>
            </div>
            <div class="row justify-content-center">
                <div v-if="loading" class="loader">
                    <img src="../assets/img/loader.gif" alt="Загрузка" />
                    <p>Загрузка</p>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    import ai_helper from '../js/aihelper/ai_helper';
    import AI_helperItemClass from '../js/aihelper/classes/ai_helperItemClass.js';
    import AI_helperComplectClass from '../js/aihelper/classes/ai_helperComplectClass.js';
    import ServiceClass from "../js/rm_katris/main/ServiceClass";
    import RMCalc from "../js/rm_katris/main/RMCalc";
    import rm_katris from "../js/rm_katris/app";

    let series = require("async-series");

    let basketStorage

    export default {
        name: "Basket",
        metaInfo: {
            title: 'Корзина - Ваш заказ',
            titleTemplate: '%s - sale.katris'
        },
        filters: {
            fixed(value) {
                return value.toFixed(2)
            },
            separate(value) {
                let parts = value.toString().split(".");
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                return parts.join(".");
            }
        },
        data() {
            return {
                mode: 1,
                items: [],
                crm: {
                    fullsum: 0,
                    salesum: 0,
                    saletotalsum: 0,
                    fullsumPreview: 0,
                    salesumPreview: 0,
                    saletotalsumPreview: 0
                },
                deliveryTypes: {},
                payers: [],
                orderPayerID: -1,
                orderDeliveryID: -1,
                orderNumber: '',
                orderInfo: {
                    date: '',
                    idByClient: ''
                },
                orderSent: false,
                sets: [],
                manualSet: {},
                empty: false,
                handEmpty: false,
                deleted: false,
                count: {
                    number: 0,
                    basket: 0,
                    manual: 0
                },
                changes: {
                    removed: [],
                    changed: []
                },
                checked: false,
                action4: [10484, 10510, 30003924, 30003926, 30003927, 30003931, 30003934, 30003937, 30003938, 30003989, 30003992, 30004055, 30004059, 30004141, 30004157, 30004163, 30004164, 30004170, 30004172, 30004173, 30004176, 30004179, 30004205, 30004232, 30004233, 30004235, 30004276, 30004277, 30004278, 30004469, 30004470, 30004471, 30004472, 30004473, 30004474, 30004515, 30004516, 30004517, 30004518, 30004526, 30004534, 30004563, 30004571, 30004575, 30004576],
                aiTotal: 0,
                manualFlag: false,
                AICalculated: false,
                manualAICalculated: false,
                allMaterials: {},
                calculatedSets: [],
                gotoConfig: false,
                calcOrderSetComplexFix: false,
                addFromManualToAIArray: [],
                operatingSet: {},
                calcOrderFullSum: 0,
                calcOrderSaleSum: 0,
                totalPercents: 0,
                totalSalePercents: 0,
                jsonKatris: [],
                orderHint: false,
                rm: {
                    itemsStorageRolo: [],
                    itemsStorageHorizontal: [],
                    itemsRolo: [],
                    itemsHorizontal: [],
                    itemsHorizontalBlister: [],
                    itemsCorniceVertical: [],
                    itemsMaterialVertical: [],
                    itemsMatRolo: []
                },
                readyMade: {
                    basket: {
                        totalCount: 0,

                        totalPrice: 0,
                        totalSaleSum: 0,
                        totalTotal: 0,

                        totalPriceCornice: 0,
                        totalCorniceSale: 0,
                        totalCornice: 0
                    }
                },
                nextSale: 0,
                nextItems: 0,
                loading: true,
            }
        },
        computed: {
            setsInBusket() {
                let sorted = [];
                for (let key in this.sets) {
                    if (this.sets[key].inBusket) sorted.push(this.sets[key]);
                }
                return sorted;
            },
            notFullSets() {
                let sorted = [];
                for (let key in this.sets) {
                    if ((!this.sets[key].full || this.sets[key].recalcFlag) && this.sets[key].id != 0) sorted.push(this.sets[key])
                }
                return sorted;
            }
        },
        created() {
            let self = this;

            rm_katris.params.url = 'https://sale.katris.ru/proxy/';
            rm_katris.params.session = this.$session.get('user');
            rm_katris.user = this.$session.get('user');

            series([
                function (done) {
                    rm_katris.init(function () {
                        self.readyMade = rm_katris;
                        done()
                    })
                },
                function (done) {
                    ai_helper.makePost('aiHelper', 'get_all_materials', {}, null, function (respond) {
                        if (respond.status === 'OK') {
                            self.allMaterials = respond.data;

                            self.init();
                            done()
                        }
                    });
                },
                function() {
                    basketStorage = new ServiceClass('rmItemsBasket')

                    let rmItems = basketStorage.get('items')
                    let rmItemsCorniceVertical = basketStorage.get('itemsCorniceVertical')
                    let rmItemsMaterialVertical = basketStorage.get('itemsMaterialVertical')

                    for (let obj in rmItems) {
                        if (rmItems[obj].storage) {
                            if (rmItems[obj].mid == 6 || rmItems[obj].mid == 5 || rmItems[obj].mid == 13) {
                                self.rm.itemsStorageRolo.push(new RMCalc(rm_katris, rmItems[obj].mid))
                                self.rm.itemsStorageRolo[self.rm.itemsStorageRolo.length - 1].template = rmItems[obj]
                            }
                            if (rmItems[obj].mid == 14 || rmItems[obj].mid == 140 || rmItems[obj].mid == 141) {
                                self.rm.itemsStorageHorizontal.push(new RMCalc(rm_katris, rmItems[obj].mid))
                                self.rm.itemsStorageHorizontal[self.rm.itemsStorageHorizontal.length - 1].template = rmItems[obj]
                            }
                        } else if (rmItems[obj].byMat) {
                            self.rm.itemsMatRolo.push(new RMCalc(rm_katris, rmItems[obj].mid))
                            self.rm.itemsMatRolo[self.rm.itemsMatRolo.length - 1].template = rmItems[obj]
                        } else {
                            if (rmItems[obj].mid == 6 || rmItems[obj].mid == 5 || rmItems[obj].mid == 13) {
                                self.rm.itemsRolo.push(new RMCalc(rm_katris, rmItems[obj].mid))
                                self.rm.itemsRolo[self.rm.itemsRolo.length - 1].template = rmItems[obj]
                            }
                            if (rmItems[obj].mid == 140) {
                                self.rm.itemsHorizontalBlister.push(new RMCalc(rm_katris, rmItems[obj].mid))
                                self.rm.itemsHorizontalBlister[self.rm.itemsHorizontalBlister.length - 1].template = rmItems[obj]
                            }
                            if (rmItems[obj].mid == 141) {
                                self.rm.itemsHorizontal.push(new RMCalc(rm_katris, rmItems[obj].mid))
                                self.rm.itemsHorizontal[self.rm.itemsHorizontal.length - 1].template = rmItems[obj]
                            }
                        }
                    }

                    for (let obj in rmItemsCorniceVertical) {
                        self.rm.itemsCorniceVertical.push(new RMCalc(rm_katris, rmItemsCorniceVertical[obj].mid))
                        self.rm.itemsCorniceVertical[self.rm.itemsCorniceVertical.length - 1].template = rmItemsCorniceVertical[obj]
                    }

                    for (let obj in rmItemsMaterialVertical) {
                        self.rm.itemsMaterialVertical.push(new RMCalc(rm_katris, rmItemsMaterialVertical[obj].mid))
                        self.rm.itemsMaterialVertical[self.rm.itemsMaterialVertical.length - 1].template = rmItemsMaterialVertical[obj]
                    }

                    self.RMBasketUpdate()

                    setTimeout(() => self.loading = false, 1000);
                    // self.loading = false

                    // console.log(self.rm)
                    // console.log(rm_katris)
                }
            ])
        },
        mounted() {
            window.onscroll = function() {
                stick()
            };

            let navbar = document.getElementById("title");

            let sticky = navbar.offsetTop;

            function stick() {
                if (window.pageYOffset >= sticky && document.body.clientHeight > 1550) {
                    navbar.classList.add("sticky")
                } else {
                    navbar.classList.remove("sticky");
                }
            }
        },
        methods: {
            init: function() {
                let self = this;

                let params = {
                    url: 'https://sale.katris.ru/proxy/',
                    session: this.$session.get('user')
                };

                ai_helper.init(params, function () {
                    ai_helper.restoreComplects();

                    ai_helper.getOrderItems(function (data) {
                        self.items = data.items;
                        // console.log(self.items)
                    });

                    setTimeout(function () {
                        ai_helper.check_complect();
                    }, 500);

                    self.crm = ai_helper;

                    let changes = false;

                    let counter = 0;

                    // let saleChanged = false;

                    self.sets = [];
                    self.manualSet = {};

                    for (let complect in ai_helper.complects) {
                        counter++;

                        // if (ai_helper.complects[complect].id == 0) {
                        //     console.log(ai_helper.complects[complect])
                        //     for (let good in ai_helper.complects[complect].goods) {
                        //         console.log(ai_helper.complects[complect].goods[good])
                        //     }
                        // }

                        // if (!self.checked) {
                        //     if (ai_helper.complects[complect].date) {
                        //         let today = new Date();
                        //
                        //         if (today - new Date(ai_helper.complects[complect].date) > 86400000 || new Date(ai_helper.complects[complect].date).getTime() < 1618470011559) {
                        //             if (ai_helper.complects[complect].id != 0) {
                        //                 let groups_request = [];
                        //                 if (ai_helper.complects[complect].groups[0]) {
                        //                     for (let key in ai_helper.complects[complect].groups) {
                        //                         if (Object.prototype.hasOwnProperty.call(ai_helper.complects[complect].groups, key)) {
                        //                             groups_request.push({
                        //                                 id: ai_helper.complects[complect].groups[key].id,
                        //                                 id_good_inet: ai_helper.complects[complect].groups[key].id_good_inet,
                        //                                 gids: ai_helper.complects[complect].groups[key].gids
                        //                             });
                        //                         }
                        //                     }
                        //                 }
                        //
                        //                 ai_helper.complects[complect].get_groups_bubbles(groups_request, function (data) {
                        //                     for (let group in ai_helper.complects[complect].groups) {
                        //                         // console.log('test', data[ai_helper.complects[complect].groups[group].id])
                        //                         for (let item in ai_helper.complects[complect].groups[group].items) {
                        //                             let oldItem = ai_helper.complects[complect].groups[group].items[item];
                        //                             let newItem = data[ai_helper.complects[complect].groups[group].id][ai_helper.complects[complect].groups[group].items[item].id];
                        //
                        //                             // console.log(newItem)
                        //                             // console.log(oldItem.price)
                        //
                        //                             // oldItem.sale_exceptions = [];
                        //
                        //                             if (JSON.stringify(oldItem.sale_exceptions) != JSON.stringify(ai_helper.sale_exceptions)) {
                        //                                 saleChanged = true;
                        //                             }
                        //
                        //                             // console.log(oldItem.sale_exceptions)
                        //
                        //                             oldItem.discount_pics_ids = ai_helper.discount_pics_ids;
                        //                             oldItem.sale_exceptions = ai_helper.sale_exceptions;
                        //                             oldItem.sale_exceptions_cashback = ai_helper.sale_exceptions_cashback;
                        //
                        //                             newItem.setName = ai_helper.complects[complect].hh + ' ' + ai_helper.complects[complect].hh_add;
                        //
                        //                             if (!newItem.enableStock) {
                        //                                 self.changes.removed.push(newItem);
                        //                                 changes = true;
                        //                                 ai_helper.complects[complect].groups[group].deleteItem(oldItem);
                        //                                 ai_helper.complects[complect].groups[group].items.splice(item, 1);
                        //                                 console.log('remove');
                        //                             } else {
                        //                                 if (oldItem.price != newItem.price || oldItem.has_priv != newItem.has_priv || oldItem.gdsInStock != newItem.gdsInStock) {
                        //                                     if (oldItem.price != newItem.price) {
                        //                                         console.log('change');
                        //                                         self.changes.changed.push(newItem);
                        //                                         changes = true;
                        //
                        //                                         oldItem.price = newItem.price;
                        //                                     }
                        //
                        //                                     oldItem.has_priv = newItem.has_priv;
                        //                                     oldItem.gdsInStock = newItem.gdsInStock;
                        //
                        //                                     oldItem.setDomValues();
                        //                                 } else {
                        //                                     console.log('no changes');
                        //                                 }
                        //                             }
                        //                         }
                        //                     }
                        //
                        //                     if (saleChanged) {
                        //                         // alert('Произведен перерасчет заказа!');
                        //                     }
                        //
                        //                     if (counter == ai_helper.complects.length) {
                        //                         if (changes) self.$modal.show('changes');
                        //                         ai_helper.check_complect();
                        //                         self.checked = true;
                        //                         ai_helper.complects[complect].date = new Date();
                        //                     }
                        //
                        //                 });
                        //             } else {
                        //                 ai_helper.makePost('aiHelper', 'get_common_bubble', {}, null, function (respond) {
                        //                     if (respond.status === 'OK') {
                        //                         // console.log(respond.data.items)
                        //                         for (let item in ai_helper.complects[complect].goods) {
                        //                             let oldItem = ai_helper.complects[complect].goods[item];
                        //                             let newItem = respond.data.items[ai_helper.complects[complect].goods[item].id];
                        //
                        //                             // newItem.price = 100; //test
                        //
                        //                             newItem.setName = 'Ручной заказ';
                        //
                        //                             oldItem.discount_pics_ids = ai_helper.discount_pics_ids;
                        //                             oldItem.sale_exceptions = ai_helper.sale_exceptions;
                        //                             oldItem.sale_exceptions_cashback = ai_helper.sale_exceptions_cashback;
                        //
                        //                             // console.log('test', oldItem, newItem);
                        //
                        //                             if (!newItem.enableStock) {
                        //                                 self.changes.removed.push(newItem);
                        //                                 changes = true;
                        //                                 ai_helper.complects[complect].goods.splice(item, 1);
                        //                                 console.log('remove');
                        //                             } else {
                        //                                 if (oldItem.price != newItem.price || oldItem.has_priv != newItem.has_priv || oldItem.gdsInStock != newItem.gdsInStock) {
                        //                                     if (oldItem.price != newItem.price) {
                        //                                         console.log('change');
                        //                                         self.changes.changed.push(newItem);
                        //                                         changes = true;
                        //
                        //                                         oldItem.price = newItem.price;
                        //                                     }
                        //
                        //                                     oldItem.has_priv = newItem.has_priv;
                        //                                     oldItem.gdsInStock = newItem.gdsInStock;
                        //
                        //                                     oldItem.setDomValues();
                        //                                 } else {
                        //                                     console.log('no changes');
                        //                                 }
                        //                             }
                        //                         }
                        //                     }
                        //
                        //                     if (counter == ai_helper.complects.length) {
                        //                         if (changes) self.$modal.show('changes');
                        //                         ai_helper.check_complect();
                        //                         self.checked = true;
                        //                         ai_helper.complects[complect].date = new Date();
                        //                     }
                        //                 });
                        //             }
                        //         }
                        //     } else {
                        //         ai_helper.complects[complect].date = new Date();
                        //     }
                        // }

                        if (counter == ai_helper.complects.length) {
                            if (changes) self.$modal.show('changes');
                            ai_helper.check_complect();
                            self.checked = true;
                            ai_helper.complects[complect].date = new Date();
                        }

                        ai_helper.complects[complect].get_basket_sum();
                        if (ai_helper.complects[complect].id != 0) {
                            ai_helper.complects[complect].recalcFlag = false;
                            if (ai_helper.complects[complect].inBusket) self.sets.push(ai_helper.complects[complect]);

                            // console.log('set', ai_helper.complects[complect])
                            // if (ai_helper.complects[complect].inBusket) self.aiTotal += ai_helper.complects[complect].saletotalsum;

                            ai_helper.complects[complect].items = [];
                            for (let group in ai_helper.complects[complect].groups) {
                                for (let item in ai_helper.complects[complect].groups[group].items) {
                                    ai_helper.complects[complect].groups[group].items[item].good = false;
                                    ai_helper.complects[complect].groups[group].items[item].groupId = ai_helper.complects[complect].groups[group].id;
                                    ai_helper.complects[complect].items.push(ai_helper.complects[complect].groups[group].items[item]);
                                }
                            }
                            for (let good in ai_helper.complects[complect].goods) {
                                if (ai_helper.complects[complect].goods[good].added) {
                                    ai_helper.complects[complect].goods[good].good = true;
                                    ai_helper.complects[complect].goods[good].groupId = 0;
                                    ai_helper.complects[complect].items.push(ai_helper.complects[complect].goods[good]);
                                }
                            }
                        } else {
                            // console.log('123')

                            self.manualFlag = true;
                            self.manualSet = ai_helper.complects[complect];
                            for (let item in ai_helper.complects[complect].goods) {
                                ai_helper.complects[complect].goods[item].good = true;
                                ai_helper.complects[complect].goods[item].groupId = 0;
                                ai_helper.complects[complect].items.push(ai_helper.complects[complect].goods[item]);

                                self.checkAISale(ai_helper.complects[complect]);
                                self.recalcAIHelper();
                            }
                        }

                        setTimeout(function() {
                            self.recalcAIHelper();
                        }, 2500);
                    }
                });
            },
            openOrder: function() {
                this.$modal.hide('calcOrder');
                // alert('Технические работы. Отправьте заказ позже.');
                let self = this;
                ai_helper.getOrderItems(function(data) {
                    let er = '';
                    if (data.order.length <= 0) er += 'Заказ не содержит ни одной позиции! \n';
                    if (ai_helper.fullsum <= 0) er += 'Вы не можете отправить пустой заказ! \n';
                    if (!er) {
                        ai_helper.makePost('aiHelper', 'payersList', {}, null, function(respond) {
                            if (respond.status === 'OK') {
                                self.payers = [];
                                for (let key in respond.data.payers) {
                                    self.payers.push({id: key, name: respond.data.payers[key].showName});
                                }
                                if (respond.data.deliveries) self.deliveryTypes = respond.data.deliveries;
                            }
                        });
                        self.$modal.show('order');
                    } else
                        alert(er);
                });
            },
            closeOrder: function() {
                this.$modal.hide('order')
            },
            sendOrder: function() {
                let self = this;
                if (this.orderNumber != '' && this.orderDeliveryID != -1 && this.orderPayerID != -1) {
                    this.orderSent = true;

                    ai_helper.num = this.orderNumber;
                    ai_helper.delivery = this.orderDeliveryID;
                    ai_helper.payer = this.orderPayerID;

                    let commonSet = false;

                    for (let key in ai_helper.complects) {
                        let type = 0;

                        if (ai_helper.complects[key].id == '0') {
                            commonSet = ai_helper.complects[key];
                            type = 3;
                        } else if (ai_helper.complects[key].full) {
                            type = 1;
                        } else {
                            type = 2;
                        }

                        ai_helper.makePost('katrisService', 'saveOrderTypeStat', {
                            'token': self.$session.get('jwt'),
                            type: type
                        }, null, function (respond) {
                            console.log(respond)
                        });
                    }

                    if (commonSet) {
                        let xmlStatIDs = [];

                        for (let item in commonSet.goods) {
                            if (commonSet.goods[item].xmlId != 0) {
                                let xmlIDexist = false;
                                for (let i = 0; i < xmlStatIDs.length; i++) {
                                    if (xmlStatIDs[i] == commonSet.goods[item].xmlId) xmlIDexist = true
                                }
                                if (!xmlIDexist) xmlStatIDs.push(commonSet.goods[item].xmlId);
                            }
                        }

                        for (let i = 0; i < xmlStatIDs.length; i++) {
                            ai_helper.makePost('katrisService', 'updateXmlStatistic', {
                                id: xmlStatIDs[i]
                            }, null, function (respond) {
                                console.log(respond)
                            });
                        }
                    }

                    ai_helper.prepareComplectOrder();
                } else {
                    alert('Не все поля корректно заполнены!');
                }
            },
            sendOrderRM: function() {
                this.orderSent = true;
                rm_katris.num = this.orderNumber;
                rm_katris.delivery = this.orderDeliveryID;
                rm_katris.payer = this.orderPayerID;
                rm_katris.proccessDoneSend();
            },
            clearBasket: function() {
                window.localStorage.removeItem(ai_helper.storage_id);

                ai_helper.complects = [];
                ai_helper.ids = [];

                this.$countGlobal.basket = 0;
                this.$countGlobal.manual = 0;
                this.$countGlobal.manual2 = 0;

                this.$router.push({path: '/accessoriesOrdering'});
            },
            remove: function(setId) {
                let self = this;
                let set = self.sets.find(complect => complect.id == setId);
                set.inBusket = false;
                ai_helper.storeComplects();

                for (let key in self.sets) {
                    if (self.sets[key].id == setId) {
                        self.sets.splice(key, 1);
                    }
                }

                this.$countGlobal.number = 0;
                this.$countGlobal.basket = 0;
                this.$countGlobal.manual2 = 0;

                for (let key in ai_helper.complects) {
                    if (ai_helper.complects[key] != 'empty') {
                        // console.log(ai_helper.complects[key].inBusket)
                        if (ai_helper.complects[key].id != 0) {
                            if (ai_helper.complects[key].inBusket)
                                this.$countGlobal.basket++;
                            else
                                this.$countGlobal.number++;
                        } else {
                            for (let good in ai_helper.complects[key].goods) {
                                if (ai_helper.complects[key].goods[good].partner) {
                                    this.$countGlobal.manual2++
                                }
                            }

                            this.$countGlobal.manual = Object.keys(ai_helper.complects[key].goods).length - this.$countGlobal.manual2;
                        }
                    }
                }

                this.count = this.$countGlobal;

                if (this.$countGlobal.basket + this.$countGlobal.manual + this.$countGlobal.manual2 == 0) {
                    self.empty = true;
                }

                ai_helper.check_complect();

                if (self.manualFlag) self.checkAISale(self.manualSet);
                self.recalcAIHelper();

                setTimeout(function() {
                    self.recalcAIHelper();
                }, 2500);

                self.deleted = true;
                setTimeout(function() {
                    self.deleted = false;
                }, 2500);
            },
            removeItem: function(setId, itemId, groupId, good) {
                // console.log(setId, itemId, groupId, good);
                let self = this;
                let set;
                if (setId != 0)
                    set = self.sets.find(complect => complect.id == setId);
                else {
                    set = self.manualSet;
                }

                // console.log(set)

                for (let item in set.items) {
                    if (set.items[item].id == itemId) {
                        set.items.splice(item, 1);
                    }
                }

                if (setId != 0 || !good) {
                    for (let group in set.groups) {
                        if (set.groups[group].id == groupId) {
                            let item = set.groups[group].items.find(item => item.id == itemId);
                            for (let item in set.groups[group].items) {
                                if (set.groups[group].items[item].id == itemId) {
                                    set.groups[group].items.splice(item, 1);
                                }
                            }
                            set.groups[group].deleteItem(item);
                        }
                    }
                } else {
                    for (let item in set.goods) {
                        if (set.goods[item].id == itemId) {
                            delete set.goods[item];

                            this.$countGlobal.number = 0;
                            this.$countGlobal.basket = 0;
                            this.$countGlobal.manual2 = 0;

                            for (let key in ai_helper.complects) {
                                if (ai_helper.complects[key] != 'empty') {
                                    // console.log(ai_helper.complects[key].inBusket)
                                    if (ai_helper.complects[key].id != 0) {
                                        if (ai_helper.complects[key].inBusket)
                                            self.$countGlobal.basket++;
                                        else
                                            self.$countGlobal.number++;
                                    } else {
                                        // console.log('goods', ai_helper.complects[key].goods)
                                        for (let good in ai_helper.complects[key].goods) {
                                            if (ai_helper.complects[key].goods[good].partner) {
                                                self.$countGlobal.manual2++
                                            }
                                        }

                                        self.$countGlobal.manual = Object.keys(ai_helper.complects[key].goods).length - self.$countGlobal.manual2;
                                        // console.log('count', self.$countGlobal.manual)
                                    }
                                }
                            }

                            if (this.$countGlobal.basket + this.$countGlobal.manual + this.$countGlobal.manual2 == 0) {
                                self.empty = true;
                            }

                            this.count = this.$countGlobal;

                            // set.goods.splice(item, 1);

                            if (Object.keys(set.goods).length == 0) {
                                if (setId == 0) {
                                    self.handEmpty = true;
                                    self.manualFlag = false;
                                }

                                for (let set in self.sets) {
                                    if (set.id == setId) {
                                        self.sets.splice(set, 1);
                                    }
                                }

                                for (let key in ai_helper.complects) {
                                    if (ai_helper.complects[key].id == setId) {
                                        delete ai_helper.complects[key];
                                        // ai_helper.complects.splice(key, 1);
                                    }
                                }
                            }
                        }
                    }
                }

                ai_helper.storeComplects();
                ai_helper.check_complect();

                if (self.manualFlag) self.checkAISale(self.manualSet);
                self.recalcAIHelper();

                setTimeout(function() {
                    self.recalcAIHelper();
                }, 2500);
            },
            recalcAIHelper: function() {
                let self = this;
                // self.manualAICalculated = false;
                self.AICalculated = false;
                self.aiTotal = 0;

                // console.log('se', ai_helper.sale_exceptions);
                // console.log('se2', ai_helper.sale_exceptions_cashback);

                for (let complect in ai_helper.complects) {
                    if (ai_helper.complects[complect].id != 0) {
                        if (ai_helper.complects[complect].inBusket) {
                            // console.log('fullSet', ai_helper.complects[complect].full)

                            if (ai_helper.complects[complect].full) {
                                self.aiTotal += ai_helper.complects[complect].saletotalsum;
                            } else {
                                let sale = ai_helper.complects[complect].getSaleBySum(ai_helper.complects[complect].fullsum, ai_helper.user.sale_limits.full);

                                let curr = ai_helper.complects[complect].getSumBySale(sale, ai_helper.user.sale_limits.full);
                                if (curr.sum <= ai_helper.complects[complect].fullsum && sale.sale >= 30) {
                                    sale.sale = 35;
                                }

                                ai_helper.complects[complect].aiCalculatedSale = sale.sale;

                                self.AICalculated = true;

                                let sum = ai_helper.complects[complect].basket_sum - (ai_helper.complects[complect].basket_sum * (sale.sale / 100))

                                self.aiTotal += sum;

                                for (let group in ai_helper.complects[complect].groups) {
                                    for (let item in ai_helper.complects[complect].groups[group].items) {
                                        let itemSale = self.checkSale(ai_helper.complects[complect].groups[group].items[item], sale.sale);
                                        // console.log('sl', sale.sale, itemSale)

                                        let exeption = false

                                        for (let ex in ai_helper.sale_exceptions) {
                                            for (let id in ai_helper.sale_exceptions[ex].ids) {
                                                if (ai_helper.sale_exceptions[ex].ids[id] == ai_helper.complects[complect].groups[group].items[item].id && !exeption) {
                                                    if (ai_helper.sale_exceptions[ex].sales[itemSale]) {
                                                        console.log(123, ai_helper.sale_exceptions[ex].sales[itemSale])
                                                        itemSale = ai_helper.sale_exceptions[ex].sales[itemSale]
                                                        exeption = true
                                                    }
                                                }
                                            }
                                        }

                                        let saleAIsum = ai_helper.complects[complect].groups[group].items[item].sum - (ai_helper.complects[complect].groups[group].items[item].sum * (itemSale / 100))
                                        let saleAIprice = ai_helper.complects[complect].groups[group].items[item].priceRub - (ai_helper.complects[complect].groups[group].items[item].priceRub * (itemSale / 100))

                                        // console.log('temp', saleAIsum, saleAIprice)

                                        if (parseFloat(saleAIprice.toFixed(2)) <= parseFloat(ai_helper.complects[complect].groups[group].items[item].priceRubSale.toFixed(2))) {
                                            ai_helper.complects[complect].groups[group].items[item].aiCalculatedPrice = saleAIprice;
                                            if (parseFloat(saleAIprice.toFixed(2)) == parseFloat(ai_helper.complects[complect].groups[group].items[item].priceRubSale.toFixed(2))) {
                                                ai_helper.complects[complect].groups[group].items[item].aiCalculatedSum = ai_helper.complects[complect].groups[group].items[item].sale_sum;
                                            } else {
                                                ai_helper.complects[complect].groups[group].items[item].aiCalculatedSum = saleAIsum;
                                            }
                                            ai_helper.complects[complect].groups[group].items[item].aiCalculatedSale = itemSale;
                                        } else {
                                            // console.log('no', saleAIprice.toFixed(2), ai_helper.complects[complect].groups[group].items[item].priceRubSale.toFixed(2), (parseFloat(saleAIprice.toFixed(2)) <= parseFloat(ai_helper.complects[complect].groups[group].items[item].priceRubSale.toFixed(2))))
                                        }
                                    }
                                }

                                for (let item in ai_helper.complects[complect].goods) {
                                    let itemSale = self.checkSale(ai_helper.complects[complect].goods[item], sale.sale);

                                    let exeption = false

                                    for (let ex in ai_helper.sale_exceptions) {
                                        for (let id in ai_helper.sale_exceptions[ex].ids) {
                                            if (ai_helper.sale_exceptions[ex].ids[id] == ai_helper.complects[complect].goods[item].id && !exeption) {
                                                if (ai_helper.sale_exceptions[ex].sales[itemSale]) {
                                                    console.log(123, ai_helper.sale_exceptions[ex].sales[itemSale])
                                                    itemSale = ai_helper.sale_exceptions[ex].sales[itemSale]
                                                    exeption = true
                                                }
                                            }
                                        }
                                    }

                                    let saleAIsum = ai_helper.complects[complect].goods[item].sum - (ai_helper.complects[complect].goods[item].sum * (itemSale / 100));
                                    let saleAIprice = ai_helper.complects[complect].goods[item].priceRub - (ai_helper.complects[complect].goods[item].priceRub * (itemSale / 100));

                                    if (parseFloat(saleAIprice.toFixed(2)) <= parseFloat(ai_helper.complects[complect].goods[item].priceRubSale.toFixed(2))) {
                                        ai_helper.complects[complect].goods[item].aiCalculatedPrice = saleAIprice;
                                        if (parseFloat(saleAIprice.toFixed(2)) == parseFloat(ai_helper.complects[complect].goods[item].priceRubSale.toFixed(2))) {
                                            ai_helper.complects[complect].goods[item].aiCalculatedSum = ai_helper.complects[complect].goods[item].sale_sum;
                                        } else {
                                            ai_helper.complects[complect].goods[item].aiCalculatedSum = saleAIsum;
                                        }
                                        ai_helper.complects[complect].goods[item].aiCalculatedSale = itemSale;
                                    }
                                }
                            }

                        }
                    }
                    // else {
                    //     for (let item in ai_helper.complects[complect].goods) {
                    //         if (ai_helper.complects[complect].goods[item].aiCalculatedPrice != 0) {
                    //             self.aiTotal += ai_helper.complects[complect].goods[item].aiCalculatedPrice * ai_helper.complects[complect].goods[item].count;
                    //             self.AICalculated = true;
                    //             self.manualAICalculated = true;
                    //         } else
                    //             self.aiTotal += ai_helper.complects[complect].goods[item].sale_sum;
                    //     }
                    // }
                }

                // self.calcOrderFullSum = self.aiTotal;
                // self.calcOrderSaleSum = self.crm.saletotalsum - self.aiTotal;
            },
            checkAISale: function(set) {
                let self = this;
                for (let item in set.goods) {
                    if (set.goods[item].standartSet != 0 && set.goods[item].AISaleChecked) {
                        // проверялось, нужен только перерасчет
                        self.AIItemRecalc(set.goods[item]);
                    } else if (!set.goods[item].AISaleChecked) {
                        // нужно посчитать
                        ai_helper.makePost('katrisService', 'getGoodAIHelperInfo', {id: set.goods[item].id}, null, function(respond) {
                            if (respond.status === 'OK') {
                                // console.log(respond)

                                if (respond.data.group != null && respond.data.set) {
                                    // console.log(1)
                                    self.AIItemRecalc(set.goods[item]);
                                } else {
                                    if (self.allMaterials[set.goods[item].id] && ['karniz', 'roma', 'catalog', 'access'].indexOf(self.allMaterials[set.goods[item].id].ptype) == -1) {
                                        // console.log(self.allMaterials[set.goods[item].id].ptype)
                                        // console.log(2)
                                        self.AIItemRecalc(set.goods[item]);
                                    } else {
                                        // console.log(3)
                                        set.goods[item].aiCalculatedPrice = 0;
                                    }
                                }
                            }
                        });
                    }
                }

                this.recalcAIHelper();
            },
            AIItemRecalc: function(item) {
                this.manualAICalculated = true;

                let commonSet;

                for (let set in ai_helper.complects) {
                    if (ai_helper.complects[set].id == 0) {
                        commonSet = ai_helper.complects[set];
                    }
                }

                let sale = commonSet.getSaleBySum(commonSet.fullsum, ai_helper.user.sale_limits.full);

                let curr = commonSet.getSumBySale(sale, ai_helper.user.sale_limits.full);

                if (curr.sum <= commonSet.fullsum && sale.sale >= 30) {
                    sale.sale = 35;
                }

                let itemSale = this.checkSale(item, sale.sale);

                let exeption = false

                for (let ex in ai_helper.sale_exceptions) {
                    for (let id in ai_helper.sale_exceptions[ex].ids) {
                        if (ai_helper.sale_exceptions[ex].ids[id] == item.id && !exeption) {
                            if (ai_helper.sale_exceptions[ex].sales[itemSale]) {
                                console.log(123, ai_helper.sale_exceptions[ex].sales[itemSale])
                                itemSale = ai_helper.sale_exceptions[ex].sales[itemSale]
                                exeption = true
                            }
                        }
                    }
                }

                console.log(itemSale)

                let saleAIsum = item.sum - (item.sum * (itemSale / 100))
                let saleAIprice = item.priceRub - (item.priceRub * (itemSale / 100))

                console.log(saleAIsum, saleAIprice)

                if ((parseFloat(saleAIprice.toFixed(2)) <= parseFloat(item.priceRubSale.toFixed(2)) && !item.additionalDiscount) || exeption) {
                    item.aiCalculatedPrice = saleAIprice;
                    if (parseFloat(saleAIprice.toFixed(2)) == parseFloat(item.priceRubSale.toFixed(2))) {
                        item.aiCalculatedSum = item.sale_sum;
                    } else {
                        item.aiCalculatedSum = saleAIsum;
                    }

                    item.aiCalculatedSale = itemSale;
                }
            },
            toConfig: function() {
                window.localStorage.removeItem('position');
                this.$router.push({path: '/configurator'});
            },
            checkSale: function(item, sale) {
                // console.log('item', item)
                let saleExceptions = ai_helper.sale_exceptions;

                if (saleExceptions.length > 0) {
                    let salesT = null;
                    for (let i = 0; i < saleExceptions.length; i++) {
                        if (window.in_array(item.id, saleExceptions[i].ids)) {
                            salesT = saleExceptions[i];
                            break;
                        }
                    }
                    let sales = salesT;
                    if (!sales)
                        sales = {
                            type:'',
                            sales:[],
                            limits:[],
                        };
                    if (!sales.type) sales.type ='';
                    if (!sales.sales) sales.sales =[];

                    // if (sales.type === 'sales' && !item.additionalDiscount) {
                    //     for (let key in sales.sales) {
                    //         if (Object.prototype.hasOwnProperty.call(sales.sales, key)) {
                    //             // if (this.sale >= parseInt(key)) {
                    //             if (sale >= parseInt(key)) {
                    //                 if (typeof sales.sales[key] !== "undefined") {
                    //                     sale = sales.sales[key];
                    //                 }
                    //             }
                    //         }
                    //     }
                    // }
                    // console.log('s1', sales)
                    if (sales.type === 'limits' && !item.additionalDiscount) sale = item.calcPriceSales(item.wholeSum, sales.limits);
                }

                let cashback_sale = sale;
                // let no_cashback_sale = sale;

                let saleExceptionsCashback = ai_helper.sale_exceptions_cashback;

                if (saleExceptionsCashback.length > 0 && !item.additionalDiscount) {
                    let salesT = null;
                    for (let i = 0; i < saleExceptionsCashback.length; i++) {
                        if (window.in_array(item.id, saleExceptionsCashback[i].ids)) {
                            salesT = saleExceptionsCashback[i];
                            break;
                        }
                    }
                    let sales = salesT;
                    if (sales != null) {
                        if (sales.type === 'sales') {
                            for (let key in sales.sales) {
                                // if (this.sale >= parseInt(key)) {
                                if (sale >= parseInt(key)) {
                                    if (typeof sales.sales[key] !== "undefined") {
                                        cashback_sale = sales.sales[key];
                                    }
                                }
                            }
                        }
                        //if (sales.type == 'limits') this.real_sale = this.calcPriceSales(this.wholeSum, sales.limits);
                    }
                }

                sale = cashback_sale;

                // console.log('sale end', sale)

                return sale;
            },
            calcOrder: function() {
                let self = this;

                self.calcOrderSetComplexFix = false;

                self.calcOrderFullSum = 0;
                self.calcOrderSaleSum = 0;
                self.totalPercents = 0;
                self.totalSalePercents = 0;

                let sales = [];
                let salesPlus = [];

                this.$modal.hide('changes2')
                this.$modal.show('loading')

                let check = true;

                for (let set in self.sets) {
                    if (self.sets[set].inBusket) check = false;
                }

                // series([
                //     function(done) {
                //         for (let set2 in self.sets) {
                //             if (!self.sets[set2].full) self.calcOrderSetComplexFix = true;
                //
                //             let set = self.sets[set2];
                //
                //             let ok = true;
                //
                //             let calcCount = 0;
                //             set.properCalc = 0;
                //             set.properCalcOriginal = set.calcCount;
                //             if (set.square) {
                //                 set.properCalcMeters = true;
                //                 set.properCalcOriginal = set.squareCount;
                //             }
                //
                //             let groups = [];
                //             for (let group in set.groups) {
                //                 groups.push(set.groups[group])
                //             }
                //             set.groups = groups;
                //
                //             let i = 0;
                //             // eslint-disable-next-line no-inner-declarations
                //             function checkGroup() {
                //                 console.log(set.groups[i].name, i, set.groups[i].items)
                //
                //                 let items = [];
                //
                //                 for (let item in set.groups[i].items) {
                //                     items.push(set.groups[i].items[item])
                //                 }
                //
                //                 set.groups[i].items = items;
                //
                //                 if (set.groups[i].items[0]) {
                //                     let i2 = 0;
                //
                //                     // eslint-disable-next-line no-inner-declarations
                //                     function checkItem() {
                //                         console.log(set.groups[i].items[i2].name, i2)
                //
                //                         series([
                //                             function (done) {
                //                                 ai_helper.makePost('katrisService', 'getGoodAIHelperInfo', {id: set.groups[i].items[i2].id}, null, function (respond) {
                //                                     if (respond.status === 'OK') {
                //                                         console.log(1)
                //                                         set.groups[i].items[i2].setInfo = respond.data;
                //
                //                                         if (set.groups[i].items[i2].setInfo.set == false) {
                //                                             let material;
                //                                             if (self.allMaterials[set.groups[i].items[i2].id] && ['karniz', 'roma', 'catalog', 'access'].indexOf(self.allMaterials[set.groups[i].items[i2].id]) == -1) {
                //                                                 material = self.allMaterials[set.groups[i].items[i2].id];
                //
                //                                                 let partData = {set: false};
                //
                //                                                 switch (material.ptype) {
                //                                                     case 'rolo':
                //                                                         partData = {
                //                                                             set: {
                //                                                                 id_good: "20000163",
                //                                                                 id_good_inet: "222",
                //                                                                 parm1: "D-25"
                //                                                             }
                //                                                         };
                //                                                         break;
                //                                                     case 'vblinds':
                //                                                         partData = {
                //                                                             set: {
                //                                                                 id_good: "20000131",
                //                                                                 id_good_inet: "11",
                //                                                                 parm1: "классик"
                //                                                             }
                //                                                         };
                //                                                         break;
                //                                                     case 'ks25':
                //                                                         partData = {
                //                                                             set: {
                //                                                                 id_good: "30003858",
                //                                                                 id_good_inet: "69",
                //                                                                 parm1: ""
                //                                                             }
                //                                                         };
                //                                                         break;
                //                                                     case 'karniz':
                //                                                         break;
                //                                                     case 'plisse':
                //                                                         partData = {
                //                                                             set: {
                //                                                                 id_good: "30005223",
                //                                                                 id_good_inet: "514",
                //                                                                 parm1: ""
                //                                                             }
                //                                                         };
                //                                                         break;
                //                                                     case 'roma':
                //                                                         break;
                //                                                     case 'zebra':
                //                                                         partData = {
                //                                                             set: {
                //                                                                 id_good: "20000163",
                //                                                                 id_good_inet: "228",
                //                                                                 parm1: "Zebra Slim"
                //                                                             }
                //                                                         };
                //                                                         break;
                //                                                     case 'catalog':
                //                                                         break;
                //                                                     case 'access':
                //                                                         break;
                //                                                 }
                //
                //                                                 set.groups[i].items[i2].setInfo = partData;
                //                                             }
                //                                         }
                //
                //                                         done();
                //                                     }
                //                                 })
                //                             },
                //                             function (done) {
                //                                 ai_helper.makePost('katrisService', 'getGoodsDetails', {
                //                                     'token': self.$session.get('jwt'),
                //                                     goodID: set.groups[i].items[i2].setInfo.set.id_good,
                //                                     param: set.groups[i].items[i2].setInfo.set.parm1,
                //                                     idInet: set.groups[i].items[i2].setInfo.set.id_good_inet
                //                                 }, null, function (respond) {
                //                                     if (respond.status === 'OK') {
                //                                         console.log(2)
                //                                         // console.log(respond.data)
                //                                         set.groups[i].items[i2].goodDetails = respond.data;
                //                                         done();
                //                                     }
                //                                 });
                //                             },
                //                             function () {
                //                                 ai_helper.makePost('katrisService', 'getGoodsDictionary', {
                //                                     'token': self.$session.get('jwt'),
                //                                     groupID: set.groups[i].items[i2].setInfo.set.id_good,
                //                                     param: set.groups[i].items[i2].setInfo.set.parm1,
                //                                     idInet: set.groups[i].items[i2].setInfo.set.id_good_inet
                //                                 }, null, function (respond) {
                //                                     if (respond.status === 'OK') {
                //                                         console.log(3)
                //                                         set.groups[i].items[i2].goodDictionary = respond.data;
                //
                //                                         let count = set.calcCount;
                //
                //                                         if (set.groups[i].items[i2].goodDictionary.main_record == 1) {
                //                                             let squareAmount = set.squareCount * (set.groups[i].items[i2].goodDetails.amount / 100);
                //                                             let perOne = set.groups[i].items[i2].goodDetails.amount_detail / set.groups[i].items[i2].goodDetails.amount;
                //
                //                                             if (set.square) {
                //                                                 count = squareAmount;
                //                                             }
                //                                             let setsCount = set.groups[i].items[i2].count / perOne;
                //                                             if (set.square) {
                //                                                 setsCount = setsCount / (set.groups[i].items[i2].goodDetails.amount / 100);
                //                                             }
                //                                             let properCount = count * perOne;
                //
                //                                             if (setsCount > calcCount && (set.groups[i].items[i2].count / properCount) > 1 && set.groups[i].items[i2].count - properCount >= set.groups[i].items[i2].package) {
                //                                                 calcCount = Math.ceil(setsCount);
                //                                                 if (calcCount > count) set.properCalcItem = set.groups[i].items[i2];
                //                                             }
                //                                         }
                //
                //                                         if (calcCount > count) {
                //                                             ok = false;
                //                                             set.properCalc = calcCount;
                //                                         }
                //
                //                                         i2++;
                //                                         if (i2 < set.groups[i].items.length) {
                //                                             checkItem();
                //                                         } else {
                //                                             i++;
                //                                             if (i < set.groups.length) {
                //                                                 checkGroup();
                //                                             } else {
                //                                                 if (ok) {
                //                                                     // self.$modal.hide('loading');
                //                                                     // self.addToBasket(setId);
                //                                                     set.recalcFlag = false;
                //                                                 } else {
                //                                                     // self.$modal.hide('loading');
                //                                                     // self.$modal.show('orderFixes2')
                //                                                     set.recalcFlag = true;
                //                                                     self.calcOrderSetComplexFix = true;
                //                                                 }
                //                                                 done();
                //                                             }
                //                                         }
                //                                     }
                //                                 });
                //                             }
                //                         ]);
                //                     }
                //
                //                     checkItem();
                //                 } else {
                //                     i++;
                //                     if (i < set.groups.length) {
                //                         checkGroup();
                //                     } else {
                //                         if (ok) {
                //                             // self.$modal.hide('loading');
                //                             // self.addToBasket(setId);
                //                             set.recalcFlag = false;
                //                         } else {
                //                             // self.$modal.hide('loading');
                //                             // self.$modal.show('orderFixes2')
                //                             set.recalcFlag = true;
                //                             self.calcOrderSetComplexFix = true;
                //                         }
                //                         done();
                //                     }
                //                 }
                //             }
                //             checkGroup();
                //         }
                //     },
                //     function() {
                        self.calculatedSets = [];

                        let calculationItems = [];
                        let setsInfo;

                        function next() {
                            let salesSum = 0;
                            let salesPlusSum = 0;

                            for (let sale in sales) {
                                salesSum += sales[sale];
                            }

                            for (let sale in salesPlus) {
                                salesPlusSum += salesPlus[sale];
                            }

                            self.totalPercents = salesSum / sales.length;
                            self.totalSalePercents = salesPlusSum / salesPlus.length;

                            self.$modal.hide('loading')
                            if (calculationItems[0] && calculationItems[0].setInfo) {
                                self.$modal.show('calcOrder')
                            } else {
                                self.openOrder();
                            }

                        }

                        if (self.manualFlag && check) {
                            for (let item in self.manualSet.goods) {
                                if (self.manualSet.goods[item].aiCalculatedPrice != 0) {
                                    self.manualSet.goods[item].calcSetChecked = false;
                                    calculationItems.push(self.manualSet.goods[item]);
                                }
                            }

                            if (calculationItems[0]) {
                                let ids = [];
                                let infoArray = [];

                                for (let id in calculationItems) {
                                    if (id != 0) ids += ', ';
                                    ids += calculationItems[id].id;
                                }

                                series([
                                    function(done) {
                                        ai_helper.makePost('katrisService', 'getGoodAIHelperInfoArray', {ids: ids, groupID: 0}, null, function (respond) {
                                            if (respond.status === 'OK') {
                                                infoArray = respond.data;
                                                done();
                                            }
                                        })
                                    },
                                    function (done) {
                                        let i = 0;

                                        // eslint-disable-next-line no-inner-declarations
                                        function getAllItemsInfo() {
                                            series([
                                                function (done2) {
                                                    for (let item in infoArray) {
                                                        if (infoArray[item].id_good_ref == calculationItems[i].id) {
                                                            calculationItems[i].setInfo = infoArray[item];
                                                        }
                                                    }

                                                    if (calculationItems[i].setInfo) {
                                                        if (calculationItems[i].setInfo.set == false) {
                                                            let material;

                                                            if (self.allMaterials[calculationItems[i].id] && ['karniz', 'roma', 'catalog', 'access'].indexOf(self.allMaterials[calculationItems[i].id]) == -1) {
                                                                material = self.allMaterials[calculationItems[i].id];

                                                                let partData = {set: false};

                                                                switch (material.ptype) {
                                                                    case 'rolo':
                                                                        partData = {
                                                                            set: {
                                                                                id_good: "20000163",
                                                                                id_good_inet: "222",
                                                                                parm1: "D-25"
                                                                            }
                                                                        };
                                                                        break;
                                                                    case 'vblinds':
                                                                        partData = {
                                                                            set: {
                                                                                id_good: "20000131",
                                                                                id_good_inet: "11",
                                                                                parm1: "классик"
                                                                            }
                                                                        };
                                                                        break;
                                                                    case 'ks25':
                                                                        partData = {
                                                                            set: {
                                                                                id_good: "30003858",
                                                                                id_good_inet: "69",
                                                                                parm1: ""
                                                                            }
                                                                        };
                                                                        break;
                                                                    case 'karniz':
                                                                        break;
                                                                    case 'plisse':
                                                                        partData = {
                                                                            set: {
                                                                                id_good: "30005223",
                                                                                id_good_inet: "514",
                                                                                parm1: ""
                                                                            }
                                                                        };
                                                                        break;
                                                                    case 'roma':
                                                                        break;
                                                                    case 'zebra':
                                                                        partData = {
                                                                            set: {
                                                                                id_good: "20000163",
                                                                                id_good_inet: "228",
                                                                                parm1: "Zebra Slim"
                                                                            }
                                                                        };
                                                                        break;
                                                                    case 'catalog':
                                                                        break;
                                                                    case 'access':
                                                                        break;
                                                                }

                                                                calculationItems[i].setInfo.set = partData.set;

                                                                done2();
                                                            }
                                                        } else {
                                                            done2();
                                                        }
                                                    } else {
                                                        done();
                                                    }

                                                    // ai_helper.makePost('katrisService', 'getGoodAIHelperInfo', {id: calculationItems[i].id}, null, function (respond) {
                                                    //     if (respond.status === 'OK') {
                                                    //         calculationItems[i].setInfo = respond.data;
                                                    //
                                                    //         if (calculationItems[i].setInfo.set == false) {
                                                    //             let material;
                                                    //             if (self.allMaterials[calculationItems[i].id] && ['karniz', 'roma', 'catalog', 'access'].indexOf(self.allMaterials[calculationItems[i].id]) == -1) {
                                                    //                 material = self.allMaterials[calculationItems[i].id];
                                                    //
                                                    //                 let partData = {set: false};
                                                    //
                                                    //                 switch (material.ptype) {
                                                    //                     case 'rolo':
                                                    //                         partData = {
                                                    //                             set: {
                                                    //                                 id_good: "20000163",
                                                    //                                 id_good_inet: "222",
                                                    //                                 parm1: "D-25"
                                                    //                             }
                                                    //                         };
                                                    //                         break;
                                                    //                     case 'vblinds':
                                                    //                         partData = {
                                                    //                             set: {
                                                    //                                 id_good: "20000131",
                                                    //                                 id_good_inet: "11",
                                                    //                                 parm1: "классик"
                                                    //                             }
                                                    //                         };
                                                    //                         break;
                                                    //                     case 'ks25':
                                                    //                         partData = {
                                                    //                             set: {
                                                    //                                 id_good: "30003858",
                                                    //                                 id_good_inet: "69",
                                                    //                                 parm1: ""
                                                    //                             }
                                                    //                         };
                                                    //                         break;
                                                    //                     case 'karniz':
                                                    //                         break;
                                                    //                     case 'plisse':
                                                    //                         partData = {
                                                    //                             set: {
                                                    //                                 id_good: "30005223",
                                                    //                                 id_good_inet: "514",
                                                    //                                 parm1: ""
                                                    //                             }
                                                    //                         };
                                                    //                         break;
                                                    //                     case 'roma':
                                                    //                         break;
                                                    //                     case 'zebra':
                                                    //                         partData = {
                                                    //                             set: {
                                                    //                                 id_good: "20000163",
                                                    //                                 id_good_inet: "228",
                                                    //                                 parm1: "Zebra Slim"
                                                    //                             }
                                                    //                         };
                                                    //                         break;
                                                    //                     case 'catalog':
                                                    //                         break;
                                                    //                     case 'access':
                                                    //                         break;
                                                    //                 }
                                                    //
                                                    //                 calculationItems[i].setInfo = partData;
                                                    //             }
                                                    //         }
                                                    //
                                                    //         done2();
                                                    //     }
                                                    // })
                                                },
                                                function (done2) {
                                                    if (!calculationItems[i].setInfo.details) {
                                                        ai_helper.makePost('katrisService', 'getGoodsDetails', {
                                                            'token': self.$session.get('jwt'),
                                                            goodID: calculationItems[i].setInfo.set.id_good,
                                                            param: calculationItems[i].setInfo.set.parm1,
                                                            idInet: calculationItems[i].setInfo.set.id_good_inet
                                                        }, null, function (respond) {
                                                            if (respond.status === 'OK') {
                                                                calculationItems[i].goodDetails = respond.data;
                                                                done2();
                                                            }
                                                        });
                                                    } else {
                                                        calculationItems[i].goodDetails = calculationItems[i].setInfo.details;
                                                        done2();
                                                    }
                                                },
                                                function () {
                                                    if (!calculationItems[i].setInfo.dictionary) {
                                                        ai_helper.makePost('katrisService', 'getGoodsDictionary', {
                                                            'token': self.$session.get('jwt'),
                                                            groupID: calculationItems[i].setInfo.set.id_good,
                                                            param: calculationItems[i].setInfo.set.parm1,
                                                            idInet: calculationItems[i].setInfo.set.id_good_inet
                                                        }, null, function (respond) {
                                                            if (respond.status === 'OK') {
                                                                calculationItems[i].goodDictionary = respond.data;

                                                                i++;
                                                                if (i < calculationItems.length) {
                                                                    getAllItemsInfo();
                                                                } else {
                                                                    done();
                                                                }
                                                            }
                                                        });
                                                    } else {
                                                        calculationItems[i].goodDictionary = calculationItems[i].setInfo.dictionary;
                                                        i++;
                                                        if (i < calculationItems.length) {
                                                            getAllItemsInfo();
                                                        } else {
                                                            done();
                                                        }
                                                    }
                                                }
                                            ]);

                                        }

                                        getAllItemsInfo();
                                    },
                                    function (done) {
                                        let data = {id: 0, count: 0, square: 0};
                                        ai_helper.makePost('aiHelper', 'init_info', data, null, function (respond) {
                                            setsInfo = respond.data;
                                            done();
                                        })
                                    },
                                    function () {
                                        let calcItem = 0;

                                        function calcSets() {
                                            let newSet = false;

                                            if (calcItem == 0 || !calculationItems[calcItem].calcSetChecked) {
                                                newSet = true;
                                            }

                                            if (newSet) {
                                                let calcSet;
                                                let partData = calculationItems[calcItem].setInfo;

                                                let setObj = 0;

                                                for (let key in setsInfo.complects) {
                                                    if (partData && setsInfo.complects[key].id_good == partData.set.id_good && setsInfo.complects[key].parm1 == partData.set.parm1) {
                                                        setObj = setsInfo.complects[key];
                                                    }
                                                }

                                                console.log("so", setObj)

                                                if (setObj != 0) {
                                                    calcSet = new AI_helperComplectClass(setObj, 0, ai_helper);
                                                }

                                                let calcCount = 0;

                                                //Какое кол-во считать:
                                                for (let item in calculationItems) {
                                                    if (partData && calculationItems[item].setInfo && partData.set.id_good == calculationItems[item].setInfo.set.id_good && partData.set.parm1 == calculationItems[item].setInfo.set.parm1 && calculationItems[item].goodDictionary.main_record == 1 && calculationItems[item].goodDetails) {
                                                        let perOne = calculationItems[item].goodDetails.amount_detail / calculationItems[item].goodDetails.amount;
                                                        let setsCount = calculationItems[item].count / perOne;

                                                        if (setsCount > calcCount) calcCount = Math.ceil(setsCount);
                                                    }
                                                }

                                                if (calcCount < 100) calcCount = 100;

                                                console.log('cs', calcSet)

                                                if (calcSet) {
                                                    calcSet.addedInConfig = false;
                                                    calcSet.parts(calcSet.id, calcCount, 0, false, function () {
                                                        ai_helper.getFullSum(function (fs) {
                                                            // Проверяем, какие еще позиции из корзины должны попасть в комплект
                                                            for (let calcItem2 in calculationItems) {
                                                                if (partData && calculationItems[calcItem2].setInfo && partData.set.id_good == calculationItems[calcItem2].setInfo.set.id_good && partData.set.parm1 == calculationItems[calcItem2].setInfo.set.parm1 && !calculationItems[calcItem2].calcSetChecked) {
                                                                    calculationItems[calcItem2].calcSetChecked = true;

                                                                    for (let group in calcSet.groups) {
                                                                        if (calcSet.groups[group].id_good_inet == calculationItems[calcItem2].setInfo.set.id_good_inet) {
                                                                            calculationItems[calcItem2].inBusket = true;
                                                                            calcSet.groups[group].items[calculationItems[calcItem2].id] = new AI_helperItemClass(calculationItems[calcItem2], ai_helper);
                                                                            calcSet.groups[group].event();
                                                                        }
                                                                    }

                                                                    // Товар в "А не забыли ли купить"
                                                                    if (!calculationItems[calcItem2].inBusket) {
                                                                        for (let item in calcSet.goods) {
                                                                            if (calcSet.goods[item].id == calculationItems[calcItem2].id) {
                                                                                calcSet.goods[item].added = true;
                                                                                calcSet.goods[item].count = calculationItems[calcItem2].count;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }

                                                            calcSet.fullfillSet();

                                                            fs.fullsumPreview += calcSet.get_basket_sum();
                                                            calcSet.check_complect_exe(fs);

                                                            self.calculatedSets.push(calcSet);

                                                            self.calcOrderFullSum += calcSet.saletotalsum;
                                                            self.calcOrderSaleSum += calcSet.salesum;

                                                            sales.push(calcSet.sale);
                                                            console.log(calcSet.sale, calculationItems[calcItem].sale)
                                                            salesPlus.push(calcSet.sale - calculationItems[calcItem].sale);

                                                            self.$modal.hide('loading')
                                                            self.$modal.show('calcOrder')

                                                            calcItem++;
                                                            if (calcItem < calculationItems.length) {
                                                                calcSets()
                                                            } else {
                                                                console.log('nxt11')
                                                                next();
                                                            }
                                                        })
                                                    });
                                                } else {
                                                    console.log('calcSet not found')
                                                    // next();
                                                    self.$modal.hide('loading')
                                                    self.openOrder();
                                                }
                                            } else {
                                                calcItem++;
                                                if (calcItem < calculationItems.length) {
                                                    calcSets()
                                                } else {
                                                    next();
                                                }
                                            }
                                        }

                                        if (calculationItems[0] && calculationItems[0].setInfo) {
                                            calcSets()
                                        } else {
                                            next();
                                        }
                                    }
                                ]);
                            } else {
                                self.$modal.hide('loading')
                                self.openOrder();
                            }
                        } else {
                            self.$modal.hide('loading')
                            if (self.calcOrderSetComplexFix) {
                                self.$modal.show('calcOrder')
                            } else {
                                self.openOrder();
                            }
                        }
                //     }
                // ]);
            },
            addCalculatedSet: function(set, type) {
                if (type == 0) this.gotoConfig = true;
                if (type == 1) set.inBusket = true;

                let replaced = false;

                for (let set2 in ai_helper.complects) {
                    if (ai_helper.complects[set2].id_good == set.id_good && ai_helper.complects[set2].hh_add == set.hh_add) {
                        replaced = true;
                        ai_helper.complects[set2] = set;
                    }
                }

                if (!replaced) ai_helper.complects.push(set);

                for (let item in this.manualSet.goods) {
                    if (this.manualSet.goods[item].calcSetChecked) {
                        this.removeItem(0, this.manualSet.goods[item].id, 0, true)
                    }
                }

                if (type == 0) set.addedInConfig = true;
                if (type == 1) set.addedInBasket = true;

                ai_helper.storeComplects();
                this.init();
            },
            fixSetComplex: function(set) {
                let self = this;

                self.addFromManualToAIArray = [];

                self.operatingSet = set;

                for (let group in set.groups) {
                    if (set.groups[group].restAmount > 0 && set.groups[group].bubbleItems.length > 0) {
                        for (let good in self.manualSet.goods) {
                            if (self.manualSet.goods[good].goodDetails.id_good_inet == set.groups[group].id_good_inet && set.id_good == self.manualSet.goods[good].goodDetails.id_good && self.manualSet.goods[good].goodDetails.parm1 == set.hh_add) {
                                self.addFromManualToAIArray.push(self.manualSet.goods[good]);
                            }
                        }
                    }
                }

                if (self.addFromManualToAIArray[0]) {
                    this.$modal.show('calcOrder2')
                } else {
                    this.continueOrderFix(set)
                }
            },
            manualToAI: function(set) {
                this.$modal.hide('calcOrder2')
                let self = this;

                for (let group in set.groups) {
                    if (set.groups[group].restAmount > 0 && set.groups[group].bubbleItems.length > 0) {
                        for (let good in self.manualSet.goods) {
                            if (self.manualSet.goods[good].goodDetails.id_good_inet == set.groups[group].id_good_inet && set.id_good == self.manualSet.goods[good].goodDetails.id_good && self.manualSet.goods[good].goodDetails.parm1 == set.hh_add) {
                                set.groups[group].items[self.manualSet.goods[good].id] = new AI_helperItemClass(self.manualSet.goods[good], ai_helper);
                                set.groups[group].items[self.manualSet.goods[good].id].count = self.manualSet.goods[good].count;
                                set.groups[group].items[self.manualSet.goods[good].id].sum = set.groups[group].items[self.manualSet.goods[good].id].count * set.groups[group].items[self.manualSet.goods[good].id].priceRub;
                                set.groups[group].items[self.manualSet.goods[good].id].setDomValues();
                                set.groups[group].getActualAmount();

                                self.removeItem(0, self.manualSet.goods[good].id, 0, true)
                            }
                        }
                    }
                }

                this.continueOrderFix(set)
            },
            continueOrderFix: function(set) {
                this.$modal.hide('calcOrder2')
                this.$modal.hide('calcOrder')

                set.fullfillSet();
                ai_helper.storeComplects();
                this.init();
            },
            fixPartsCount: function(set) {
                let self = this;

                self.$modal.hide('orderFixes2')

                if (set.square) {
                    set.squareCount = set.properCalc;
                } else {
                    set.calcCount = set.properCalc;
                }

                set.properCalcToBasket = false;

                let tempSet = new AI_helperComplectClass(set, 0, ai_helper);

                tempSet.parts(tempSet.id, self.properCalc, 0, false, function () {
                    // console.log(tempSet)
                    // console.log(set)

                    for (let group in tempSet.groups) {
                        // console.log(tempSet.groups[group].amount, tempSet.groups[group].restAmount, tempSet.groups[group].actualAmount, tempSet.groups[group].amountAct)
                        // console.log(set.groups[group].amount, set.groups[group].restAmount, set.groups[group].actualAmount, set.groups[group].amountAct)
                        set.groups[group].amount = tempSet.groups[group].amount;
                        set.groups[group].restAmount = tempSet.groups[group].restAmount;
                        set.groups[group].actualAmount = tempSet.groups[group].actualAmount;
                        set.groups[group].amountAct = tempSet.groups[group].amountAct;
                    }

                    self.continueOrderFix(set);
                });
            },
            checkPrice: function() {
                let self = this;

                let changes = false;

                let counter = 0;

                let saleChanged = false;

                self.orderHint = false;

                this.$modal.hide('warning')
                this.$modal.show('loading')

                let timer = 20000;
                let actual = true;

                setTimeout(function() {
                    console.log('timer')
                    showChanges();
                }, timer);

                function showChanges() {
                    console.log(actual)
                    if (actual) {
                        actual = false;

                        self.$modal.hide('loading');

                        if (changes) {
                            ai_helper.storeComplects();
                            self.init();
                            self.$modal.show('changes2');
                        } else {
                            self.calcOrder();
                        }

                        ai_helper.check_complect();
                        self.checked = true;
                    }
                }

                for (let complect in ai_helper.complects) {
                    counter++;

                    if (ai_helper.complects[complect].id != 0) {
                        let groups_request = [];
                        if (ai_helper.complects[complect].groups[0]) {
                            for (let key in ai_helper.complects[complect].groups) {
                                if (Object.prototype.hasOwnProperty.call(ai_helper.complects[complect].groups, key)) {
                                    groups_request.push({
                                        id: ai_helper.complects[complect].groups[key].id,
                                        id_good_inet: ai_helper.complects[complect].groups[key].id_good_inet,
                                        gids: ai_helper.complects[complect].groups[key].gids
                                    });
                                }
                            }
                        }

                        ai_helper.complects[complect].get_groups_bubbles(groups_request, function (data) {
                            for (let group in ai_helper.complects[complect].groups) {
                                // console.log('test', data[ai_helper.complects[complect].groups[group].id])
                                for (let item in ai_helper.complects[complect].groups[group].items) {
                                    let oldItem = ai_helper.complects[complect].groups[group].items[item];
                                    let newItem = data[ai_helper.complects[complect].groups[group].id][ai_helper.complects[complect].groups[group].items[item].id];
                                    newItem = new AI_helperItemClass(newItem, ai_helper);
                                    newItem.setDomValues();

                                    if (newItem) {
                                        if (JSON.stringify(oldItem.sale_exceptions) != JSON.stringify(ai_helper.sale_exceptions)) {
                                            saleChanged = true;
                                        }

                                        oldItem.discount_pics_ids = ai_helper.discount_pics_ids;
                                        oldItem.sale_exceptions = ai_helper.sale_exceptions;
                                        oldItem.sale_exceptions_cashback = ai_helper.sale_exceptions_cashback;

                                        newItem.setName = ai_helper.complects[complect].hh + ' ' + ai_helper.complects[complect].hh_add;

                                        //newItem.price = 1000;

                                        if (!newItem.enableStock) {
                                            self.changes.removed.push(newItem);
                                            changes = true;
                                            ai_helper.complects[complect].groups[group].deleteItem(oldItem);
                                            // console.log(ai_helper.complects[complect].groups[group].items)
                                            // ai_helper.complects[complect].groups[group].items.splice(item, 1);
                                            console.log('remove');
                                        } else {
                                            if (oldItem.priceRub != newItem.priceRub || oldItem.has_priv != newItem.has_priv || oldItem.gdsInStock != newItem.gdsInStock) {
                                                if (oldItem.priceRub != newItem.priceRub) {
                                                    console.log('change');
                                                    self.changes.changed.push(newItem);
                                                    changes = true;

                                                    oldItem.priceRub = newItem.priceRub;
                                                    oldItem.price = newItem.price;
                                                    oldItem.curRate = newItem.curRate;
                                                }

                                                oldItem.has_priv = newItem.has_priv;
                                                oldItem.gdsInStock = newItem.gdsInStock;

                                                oldItem.setDomValues();
                                            } else {
                                                console.log('no changes');
                                            }
                                        }
                                    }
                                }
                            }

                            if (saleChanged) {
                                // alert('Произведен перерасчет заказа!');
                            }

                            if (counter == ai_helper.complects.length) {
                                console.log(3)
                                showChanges();
                            }

                        });
                    } else {
                        ai_helper.makePost('aiHelper', 'get_common_bubble', {}, null, function (respond) {
                            if (respond.status === 'OK') {
                                // console.log(respond.data.items)
                                for (let item in ai_helper.complects[complect].goods) {
                                    let oldItem = ai_helper.complects[complect].goods[item];
                                    let newItem = respond.data.items[ai_helper.complects[complect].goods[item].id];
                                    newItem = new AI_helperItemClass(newItem, ai_helper);
                                    newItem.setDomValues();

                                    // newItem.priceRub = 100; //test

                                    if (newItem) {
                                        newItem.setName = 'Ручной заказ';

                                        oldItem.discount_pics_ids = ai_helper.discount_pics_ids;
                                        oldItem.sale_exceptions = ai_helper.sale_exceptions;
                                        oldItem.sale_exceptions_cashback = ai_helper.sale_exceptions_cashback;

                                        if (!newItem.enableStock) {
                                            self.changes.removed.push(newItem);
                                            changes = true;
                                            // ai_helper.complects[complect].goods.splice(item, 1);
                                            delete ai_helper.complects[complect].goods[item];
                                            console.log('remove');
                                        } else {
                                            if (oldItem.priceRub != newItem.priceRub || oldItem.has_priv != newItem.has_priv || oldItem.gdsInStock != newItem.gdsInStock) {
                                                if (oldItem.priceRub != newItem.priceRub) {
                                                    console.log('change');
                                                    self.changes.changed.push(newItem);
                                                    changes = true;

                                                    oldItem.price = newItem.price;
                                                    oldItem.priceRub = newItem.priceRub;
                                                    oldItem.curRate = newItem.curRate;
                                                }

                                                oldItem.has_priv = newItem.has_priv;
                                                oldItem.gdsInStock = newItem.gdsInStock;

                                                oldItem.setDomValues();
                                            } else {
                                                console.log('no changes');
                                            }
                                        }
                                    }
                                }
                            }

                            if (counter == ai_helper.complects.length) {
                                console.log(2)
                                showChanges();
                            }
                        });
                    }
                }

            },
            setMode: function(mode) {
                this.mode = mode;
                if (mode > 1) {
                    this.RMBasketUpdate()
                }
            },
            removeItemRM: function(id, type) {
                let self = this;
                console.log(id, type)

                self.$countGlobal.basket -= 1

                if (type == 1) {
                    self.rm.itemsStorageRolo.splice(id, 1)
                } else if (type == 2) {
                    self.rm.itemsStorageHorizontal.splice(id, 1)
                } else if (type == 3) {
                    self.rm.itemsRolo.splice(id, 1)
                } else if (type == 4) {
                    self.rm.itemsHorizontal.splice(id, 1)
                } else if (type == 5) {
                    self.rm.itemsHorizontalBlister.splice(id, 1)
                } else if (type == 6) {
                    self.rm.itemsCorniceVertical.splice(id, 1)
                } else if (type == 7) {
                    self.rm.itemsMaterialVertical.splice(id, 1)
                } else if (type == 8) {
                    self.rm.itemsMatRolo.splice(id, 1)
                }

                this.reSaveRMStorage()
            },
            reSaveRMStorage: function() {
                let self = this

                let rmItems = [], rmItemsCorniceVertical = [], rmItemsMaterialVertical = []

                for (let item in self.rm.itemsStorageRolo) {
                    rmItems.push(self.rm.itemsStorageRolo[item].template)
                }
                for (let item in self.rm.itemsStorageHorizontal) {
                    rmItems.push(self.rm.itemsStorageHorizontal[item].template)
                }
                for (let item in self.rm.itemsRolo) {
                    rmItems.push(self.rm.itemsRolo[item].template)
                }
                for (let item in self.rm.itemsHorizontal) {
                    rmItems.push(self.rm.itemsHorizontal[item].template)
                }
                for (let item in self.rm.itemsHorizontalBlister) {
                    rmItems.push(self.rm.itemsHorizontalBlister[item].template)
                }
                for (let item in self.rm.itemsCorniceVertical) {
                    rmItemsCorniceVertical.push(self.rm.itemsCorniceVertical[item].template)
                }
                for (let item in self.rm.itemsMaterialVertical) {
                    rmItemsMaterialVertical.push(self.rm.itemsMaterialVertical[item].template)
                }
                for (let item in self.rm.itemsMatRolo) {
                    rmItems.push(self.rm.itemsMatRolo[item].template)
                }


                basketStorage.set('items', rmItems)
                basketStorage.set('itemsCorniceVertical', rmItemsCorniceVertical)
                basketStorage.set('itemsMaterialVertical', rmItemsMaterialVertical)

                let basketCount = rmItems.length + rmItemsCorniceVertical.length + rmItemsMaterialVertical.length;
                basketStorage.set('basketCount', basketCount)
            },
            clearBasketRM: function() {
                let self = this
                if (this.mode == 2) {
                    self.rm.itemsStorageRolo = []
                    self.rm.itemsStorageHorizontal = []
                } else if (this.mode == 3) {
                    self.rm.itemsRolo = []
                    self.rm.itemsHorizontal = []
                    self.rm.itemsHorizontalBlister = []
                    self.rm.itemsCorniceVertical = []
                    self.rm.itemsMaterialVertical = []
                    self.rm.itemsMatRolo = []
                }
                self.RMBasketUpdate()
            },
            prepareOrderRM: function() {
                this.payersList = rm_katris.payersList;

                this.payers = [];
                for (let key in rm_katris.payersList) {
                    this.payers.push({id: key, name: rm_katris.payersList[key].showName});
                }

                this.deliveryTypes = rm_katris.deliveriesList;

                this.$modal.show('orderRM')
            },
            RMBasketUpdate() {
                let self = this

                // console.log('baskupd')

                // this.updateExcelData()
                // this.updateActionsGoodsList()

                rm_katris.basket.clear();

                if (self.mode == 2) {
                    for (let i in self.rm.itemsStorageRolo) {
                        self.rm.itemsStorageRolo[i].store();
                        self.rm.itemsStorageRolo[i].reCalc();
                        rm_katris.orderItemsConfirm(self.rm.itemsStorageRolo[i]);
                    }

                    for (let i in self.rm.itemsStorageHorizontal) {
                        self.rm.itemsStorageHorizontal[i].store();
                        self.rm.itemsStorageHorizontal[i].reCalc();
                        rm_katris.orderItemsConfirm(self.rm.itemsStorageHorizontal[i]);
                    }
                } else if (self.mode == 3) {
                    for (let i in self.rm.itemsRolo) {
                        self.rm.itemsRolo[i].store();
                        self.rm.itemsRolo[i].reCalc();
                        rm_katris.orderItemsConfirm(self.rm.itemsRolo[i]);
                    }
                    for (let i in self.rm.itemsHorizontal) {
                        self.rm.itemsHorizontal[i].store();
                        self.rm.itemsHorizontal[i].reCalc();
                        rm_katris.orderItemsConfirm(self.rm.itemsHorizontal[i]);
                    }
                    for (let i in self.rm.itemsHorizontalBlister) {
                        self.rm.itemsHorizontalBlister[i].store();
                        self.rm.itemsHorizontalBlister[i].reCalc();
                        rm_katris.orderItemsConfirm(self.rm.itemsHorizontalBlister[i]);
                    }
                    for (let i in self.rm.itemsCorniceVertical) {
                        self.rm.itemsCorniceVertical[i].store();
                        self.rm.itemsCorniceVertical[i].reCalc();
                        rm_katris.orderItemsConfirm(self.rm.itemsCorniceVertical[i]);
                    }
                    for (let i in self.rm.itemsMaterialVertical) {
                        self.rm.itemsMaterialVertical[i].store();
                        self.rm.itemsMaterialVertical[i].reCalc();
                        rm_katris.orderItemsConfirm(self.rm.itemsMaterialVertical[i]);
                    }
                    for (let i in self.rm.itemsMatRolo) {
                        self.rm.itemsMatRolo[i].store();
                        self.rm.itemsMatRolo[i].reCalc();
                        rm_katris.orderItemsConfirm(self.rm.itemsMatRolo[i]);
                    }
                }

                rm_katris.basket.reCalc();

                let itemsCount = rm_katris.basket.totalCount + rm_katris.basket.prevOrdersCount;

                let discountsActual = this.discounts;
                if (this.isPF && this.discounts_pf && this.mode == 2) {
                    discountsActual = this.discounts_pf;
                }

                for (let count in discountsActual) {
                    if (count > itemsCount) {
                        this.nextItems = count - itemsCount;
                        this.nextSale = discountsActual[count];
                        break;
                    }
                }
            },
        }
    }
</script>

<style scoped>
    .loader {
        text-align: center;
        padding: 50px 0;
    }
    .loader p {
        font-weight: bold;
        margin-top: 10px;
    }

    @media (min-width: 1200px) {
        .container, .container-sm, .container-md, .container-lg, .container-xl {
            max-width: 1340px;
        }
    }

    .saleSum {
        width: 140px;
    }

    .tableHeader {
        /*font-size: 12px;*/
        line-height: 1.2;

        font-size: 17px;
        font-weight: 600;
        text-align: center;
        /*padding: 10px 0;*/
        padding-bottom: 20px;
        position: relative;

        background: #fff;

        border-bottom: 1px solid #dee2e6;
    }
    .tableHeader td {
        padding: 3px 0.5rem;
        border-top: 1px solid #007bff;
    }

    .tableHeader td {
        font-weight: 600;
        text-align: center;
        padding: 27px 0;
        padding-top: 10px;
        padding-bottom: 30px;
        position: relative;
    }

    .tableHeader td:after {
        content: '';
        height: 30px;
        width: 1px;
        background: #adadad;
        display: block;
        position: absolute;
        right: 0;
        top: calc(50% - 15px);
    }

    .tableHeader td:nth-last-of-type(1):after {
        background: #fff;
    }

    .tableHeader td i {
        position: absolute;
        bottom: 5px;
        left: calc(50% - 8px);
    }

    .item td {
        position: relative;
    }
    .item td:after {
        content: '';
        height: 30px;
        width: 1px;
        background: #adadad;
        display: block;
        position: absolute;
        right: 0;
        top: calc(50% - 15px);

    }

    .item td.noAfter:after {
        background: #fff;
    }

    .aiTotal {
        font-weight: bold;
        font-size: 18px;
    }

    .aiTotal td {
        border-top: none;
    }

    .aiTotalTable {
        border: 5px solid #007bff;
        border-radius: 16px;
        margin-top: 20px;
    }

    .aiField {
        color: grey;
    }

    .setHead {
        position: relative;
    }

    .triangle {
        position: relative;
    }

    .triangle::after {
        content: '';
        position: absolute;
        left: calc(50% - 30px);
        bottom: 47px;
        border: 30px solid transparent; border-bottom: 30px solid #83beff;
    }

    .orderHintBlock {
        border: 2px solid #83beff;
        border-radius: 2rem;
    }

    .blockClose {
        border: none;
    }
    .blockClose:hover {
        color: #007bff;
        background-color: transparent;
    }
</style>
